var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastBack0101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 389 272.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#linear-gradient);}.cls-4{opacity:0.13;}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:url(#linear-gradient-9);}.cls-13{fill:url(#linear-gradient-10);}.cls-14{fill:url(#linear-gradient-11);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-13);}.cls-17{fill:url(#linear-gradient-14);}.cls-18{fill:url(#linear-gradient-15);}.cls-19{fill:url(#linear-gradient-16);}.cls-20{fill:url(#linear-gradient-17);}.cls-21{fill:url(#linear-gradient-18);}.cls-22{fill:url(#linear-gradient-19);}.cls-23{fill:url(#linear-gradient-20);}.cls-24{fill:url(#linear-gradient-21);}.cls-25{fill:url(#linear-gradient-22);}.cls-26{fill:url(#linear-gradient-23);}.cls-27{fill:url(#linear-gradient-24);}.cls-28{fill:url(#linear-gradient-25);}.cls-29{fill:url(#linear-gradient-26);}.cls-30{fill:url(#linear-gradient-27);}.cls-31{fill:url(#linear-gradient-28);}.cls-32{fill:url(#linear-gradient-29);}.cls-33{fill:url(#linear-gradient-30);}.cls-34{fill:url(#linear-gradient-31);}.cls-35{fill:url(#linear-gradient-32);}.cls-36{fill:url(#linear-gradient-33);}.cls-37{fill:url(#linear-gradient-34);}.cls-38{fill:url(#linear-gradient-35);}.cls-39{fill:url(#linear-gradient-36);}.cls-40{fill:url(#linear-gradient-37);}.cls-41{fill:url(#linear-gradient-38);}.cls-42{fill:url(#linear-gradient-39);}.cls-43{fill:url(#linear-gradient-40);}.cls-44{fill:url(#linear-gradient-41);}.cls-45{fill:url(#linear-gradient-42);}.cls-46{fill:url(#linear-gradient-43);}.cls-47{fill:url(#linear-gradient-44);}.cls-48{fill:url(#linear-gradient-45);}.cls-49{fill:url(#linear-gradient-46);}.cls-50{fill:url(#linear-gradient-47);}.cls-51{fill:url(#linear-gradient-48);}.cls-52{fill:url(#linear-gradient-49);}.cls-53{fill:url(#linear-gradient-50);}.cls-54{fill:url(#linear-gradient-51);}.cls-55{fill:url(#linear-gradient-52);}.cls-56{fill:url(#linear-gradient-53);}.cls-57{fill:url(#linear-gradient-54);}.cls-58{fill:url(#linear-gradient-55);}.cls-59{fill:url(#linear-gradient-56);}.cls-60{fill:url(#linear-gradient-57);}.cls-61{fill:url(#linear-gradient-58);}.cls-62{fill:url(#linear-gradient-59);}.cls-63{fill:url(#linear-gradient-60);}.cls-64{fill:url(#linear-gradient-61);}.cls-65{fill:url(#linear-gradient-62);}.cls-66{fill:url(#linear-gradient-63);}.cls-67{fill:url(#linear-gradient-64);}.cls-68{fill:url(#linear-gradient-65);}.cls-69{fill:url(#linear-gradient-66);}.cls-70{fill:url(#linear-gradient-67);}.cls-71{fill:url(#linear-gradient-68);}.cls-72{fill:url(#linear-gradient-69);}.cls-73{fill:url(#linear-gradient-70);}.cls-74{fill:url(#linear-gradient-71);}.cls-75{fill:url(#linear-gradient-72);}.cls-76{fill:url(#linear-gradient-73);}.cls-77{fill:url(#linear-gradient-74);}.cls-78{fill:url(#linear-gradient-75);}.cls-79{fill:url(#linear-gradient-76);}.cls-80{fill:url(#linear-gradient-77);}.cls-81{fill:url(#linear-gradient-78);}.cls-82{fill:url(#linear-gradient-79);}.cls-83{fill:url(#linear-gradient-80);}.cls-84{fill:url(#linear-gradient-81);}.cls-85{fill:url(#linear-gradient-82);}.cls-86{fill:url(#linear-gradient-83);}.cls-87{fill:url(#linear-gradient-84);}.cls-88{fill:url(#linear-gradient-85);}.cls-89{fill:url(#linear-gradient-86);}.cls-90{fill:url(#linear-gradient-87);}.cls-91{fill:url(#linear-gradient-88);}.cls-92{fill:url(#linear-gradient-89);}.cls-93{fill:url(#linear-gradient-90);}.cls-94{fill:url(#linear-gradient-91);}.cls-95{fill:url(#linear-gradient-92);}.cls-96{fill:url(#linear-gradient-93);}.cls-97{fill:url(#linear-gradient-94);}.cls-98{fill:url(#linear-gradient-95);}.cls-99{fill:url(#linear-gradient-96);}.cls-100{fill:url(#linear-gradient-97);}.cls-101{fill:url(#linear-gradient-98);}.cls-102{fill:url(#linear-gradient-99);}.cls-103{fill:url(#linear-gradient-100);}.cls-104{opacity:0.41;fill:url(#linear-gradient-101);}.cls-104,.cls-389{isolation:isolate;}.cls-105{fill:url(#linear-gradient-102);}.cls-106{fill:url(#linear-gradient-103);}.cls-107{fill:url(#linear-gradient-104);}.cls-108{fill:url(#linear-gradient-105);}.cls-109{fill:url(#linear-gradient-106);}.cls-110{fill:url(#linear-gradient-107);}.cls-111{fill:url(#linear-gradient-108);}.cls-112{fill:url(#linear-gradient-109);}.cls-113{fill:url(#linear-gradient-110);}.cls-114{fill:url(#linear-gradient-111);}.cls-115{fill:url(#linear-gradient-112);}.cls-116{fill:url(#linear-gradient-113);}.cls-117{fill:url(#linear-gradient-114);}.cls-118{fill:url(#linear-gradient-115);}.cls-119{fill:url(#linear-gradient-116);}.cls-120{fill:url(#linear-gradient-117);}.cls-121{fill:url(#linear-gradient-118);}.cls-122{fill:url(#linear-gradient-119);}.cls-123{fill:url(#linear-gradient-120);}.cls-124{fill:url(#linear-gradient-121);}.cls-125{fill:url(#linear-gradient-122);}.cls-126{fill:url(#linear-gradient-123);}.cls-127{fill:url(#linear-gradient-124);}.cls-128{fill:url(#linear-gradient-125);}.cls-129{fill:url(#linear-gradient-126);}.cls-130{fill:url(#linear-gradient-127);}.cls-131{fill:url(#linear-gradient-128);}.cls-132{fill:url(#linear-gradient-129);}.cls-133{fill:url(#linear-gradient-130);}.cls-134{fill:url(#linear-gradient-131);}.cls-135{fill:url(#linear-gradient-132);}.cls-136{fill:url(#linear-gradient-133);}.cls-137{fill:url(#linear-gradient-134);}.cls-138{fill:url(#linear-gradient-135);}.cls-139{fill:url(#linear-gradient-136);}.cls-140{fill:url(#linear-gradient-137);}.cls-141{fill:url(#linear-gradient-138);}.cls-142{fill:url(#linear-gradient-139);}.cls-143{fill:url(#linear-gradient-140);}.cls-144{fill:url(#linear-gradient-141);}.cls-145{fill:url(#linear-gradient-142);}.cls-146{fill:url(#linear-gradient-143);}.cls-147{fill:url(#linear-gradient-144);}.cls-148{fill:url(#linear-gradient-145);}.cls-149{fill:url(#linear-gradient-146);}.cls-150{fill:url(#linear-gradient-147);}.cls-151{fill:url(#linear-gradient-148);}.cls-152{fill:url(#linear-gradient-149);}.cls-153{fill:url(#linear-gradient-150);}.cls-154{fill:url(#linear-gradient-151);}.cls-155{fill:url(#linear-gradient-152);}.cls-156{fill:url(#linear-gradient-153);}.cls-157{fill:url(#linear-gradient-154);}.cls-158{fill:url(#linear-gradient-155);}.cls-159{fill:url(#linear-gradient-156);}.cls-160{fill:url(#linear-gradient-157);}.cls-161{fill:url(#linear-gradient-158);}.cls-162{fill:url(#linear-gradient-159);}.cls-163{fill:url(#linear-gradient-160);}.cls-164{fill:url(#linear-gradient-161);}.cls-165{fill:url(#linear-gradient-162);}.cls-166{fill:url(#linear-gradient-163);}.cls-167{fill:url(#linear-gradient-164);}.cls-168{fill:url(#linear-gradient-165);}.cls-169{fill:url(#linear-gradient-166);}.cls-170{fill:url(#linear-gradient-167);}.cls-171{fill:url(#linear-gradient-168);}.cls-172{fill:url(#linear-gradient-169);}.cls-173{fill:url(#linear-gradient-170);}.cls-174{fill:url(#linear-gradient-171);}.cls-175{fill:url(#linear-gradient-172);}.cls-176{fill:url(#linear-gradient-173);}.cls-177{fill:url(#linear-gradient-174);}.cls-178{fill:url(#linear-gradient-175);}.cls-179{fill:url(#linear-gradient-176);}.cls-180{fill:url(#linear-gradient-177);}.cls-181{fill:url(#linear-gradient-178);}.cls-182{fill:url(#linear-gradient-179);}.cls-183{fill:url(#linear-gradient-180);}.cls-184{fill:url(#linear-gradient-181);}.cls-185{fill:url(#linear-gradient-182);}.cls-186{fill:url(#linear-gradient-183);}.cls-187{fill:url(#linear-gradient-184);}.cls-188{fill:url(#linear-gradient-185);}.cls-189{fill:url(#linear-gradient-186);}.cls-190{fill:url(#linear-gradient-187);}.cls-191{fill:url(#linear-gradient-188);}.cls-192{fill:url(#linear-gradient-189);}.cls-193{fill:url(#linear-gradient-190);}.cls-194{fill:url(#linear-gradient-191);}.cls-195{fill:url(#linear-gradient-192);}.cls-196{fill:url(#linear-gradient-193);}.cls-197{fill:url(#linear-gradient-194);}.cls-198{fill:url(#linear-gradient-195);}.cls-199{fill:url(#linear-gradient-196);}.cls-200{fill:url(#linear-gradient-197);}.cls-201{fill:url(#linear-gradient-198);}.cls-202{fill:url(#linear-gradient-199);}.cls-203{fill:url(#linear-gradient-200);}.cls-204{fill:url(#linear-gradient-201);}.cls-205{fill:url(#linear-gradient-202);}.cls-206{fill:url(#linear-gradient-203);}.cls-207{fill:url(#linear-gradient-204);}.cls-208{fill:url(#linear-gradient-205);}.cls-209{fill:url(#linear-gradient-206);}.cls-210{fill:url(#linear-gradient-207);}.cls-211{fill:url(#linear-gradient-208);}.cls-212{fill:url(#linear-gradient-209);}.cls-213{fill:url(#linear-gradient-210);}.cls-214{fill:url(#linear-gradient-211);}.cls-215{fill:url(#linear-gradient-212);}.cls-216{fill:url(#linear-gradient-213);}.cls-217{fill:url(#linear-gradient-214);}.cls-218{fill:url(#linear-gradient-215);}.cls-219{fill:url(#linear-gradient-216);}.cls-220{fill:url(#linear-gradient-217);}.cls-221{fill:url(#linear-gradient-218);}.cls-222{fill:url(#linear-gradient-219);}.cls-223{fill:url(#linear-gradient-220);}.cls-224{fill:url(#linear-gradient-221);}.cls-225{fill:url(#linear-gradient-222);}.cls-226{fill:url(#linear-gradient-223);}.cls-227{fill:url(#linear-gradient-224);}.cls-228{fill:url(#linear-gradient-225);}.cls-229{fill:url(#linear-gradient-226);}.cls-230{fill:url(#linear-gradient-227);}.cls-231{fill:url(#linear-gradient-228);}.cls-232{fill:url(#linear-gradient-229);}.cls-233{fill:url(#linear-gradient-230);}.cls-234{fill:url(#linear-gradient-231);}.cls-235{fill:url(#linear-gradient-232);}.cls-236{fill:url(#linear-gradient-233);}.cls-237{fill:url(#linear-gradient-234);}.cls-238{fill:url(#linear-gradient-235);}.cls-239{fill:url(#linear-gradient-236);}.cls-240{fill:url(#linear-gradient-237);}.cls-241{fill:url(#linear-gradient-238);}.cls-242{fill:url(#linear-gradient-239);}.cls-243{fill:url(#linear-gradient-240);}.cls-244{fill:url(#linear-gradient-241);}.cls-245{fill:url(#linear-gradient-242);}.cls-246{fill:url(#linear-gradient-243);}.cls-247{fill:url(#linear-gradient-244);}.cls-248{fill:url(#linear-gradient-245);}.cls-249{fill:url(#linear-gradient-246);}.cls-250{fill:url(#linear-gradient-247);}.cls-251{fill:url(#linear-gradient-248);}.cls-252{fill:url(#linear-gradient-249);}.cls-253{fill:url(#linear-gradient-250);}.cls-254{fill:url(#linear-gradient-251);}.cls-255{fill:url(#linear-gradient-252);}.cls-256{fill:url(#linear-gradient-253);}.cls-257{fill:url(#linear-gradient-254);}.cls-258{fill:url(#linear-gradient-255);}.cls-259{fill:url(#linear-gradient-256);}.cls-260{fill:url(#linear-gradient-257);}.cls-261{fill:url(#linear-gradient-258);}.cls-262{fill:url(#linear-gradient-259);}.cls-263{fill:url(#linear-gradient-260);}.cls-264{fill:url(#linear-gradient-261);}.cls-265{fill:url(#linear-gradient-262);}.cls-266{fill:url(#linear-gradient-263);}.cls-267{fill:url(#linear-gradient-264);}.cls-268{fill:url(#linear-gradient-265);}.cls-269{fill:url(#linear-gradient-266);}.cls-270{fill:url(#linear-gradient-267);}.cls-271{fill:url(#linear-gradient-268);}.cls-272{fill:url(#linear-gradient-269);}.cls-273{fill:url(#linear-gradient-270);}.cls-274{fill:url(#linear-gradient-271);}.cls-275{fill:url(#linear-gradient-272);}.cls-276{fill:url(#linear-gradient-273);}.cls-277{fill:url(#linear-gradient-274);}.cls-278{fill:url(#linear-gradient-275);}.cls-279{fill:url(#linear-gradient-276);}.cls-280{fill:url(#linear-gradient-277);}.cls-281{fill:url(#linear-gradient-278);}.cls-282{fill:url(#linear-gradient-279);}.cls-283{fill:url(#linear-gradient-280);}.cls-284{fill:url(#linear-gradient-281);}.cls-285{fill:url(#linear-gradient-282);}.cls-286{fill:url(#linear-gradient-283);}.cls-287{fill:url(#linear-gradient-284);}.cls-288{fill:url(#linear-gradient-285);}.cls-289{fill:url(#linear-gradient-286);}.cls-290{fill:url(#linear-gradient-287);}.cls-291{fill:url(#linear-gradient-288);}.cls-292{fill:url(#linear-gradient-289);}.cls-293{fill:url(#linear-gradient-290);}.cls-294{fill:url(#linear-gradient-291);}.cls-295{fill:url(#linear-gradient-292);}.cls-296{fill:url(#linear-gradient-293);}.cls-297{fill:url(#linear-gradient-294);}.cls-298{fill:url(#linear-gradient-295);}.cls-299{fill:url(#linear-gradient-296);}.cls-300{fill:url(#linear-gradient-297);}.cls-301{fill:url(#linear-gradient-298);}.cls-302{fill:url(#linear-gradient-299);}.cls-303{fill:url(#linear-gradient-300);}.cls-304{fill:url(#linear-gradient-301);}.cls-305{fill:url(#linear-gradient-302);}.cls-306{fill:url(#linear-gradient-303);}.cls-307{fill:url(#linear-gradient-304);}.cls-308{fill:url(#linear-gradient-305);}.cls-309{fill:url(#linear-gradient-306);}.cls-310{fill:url(#linear-gradient-307);}.cls-311{fill:url(#linear-gradient-308);}.cls-312{fill:url(#linear-gradient-309);}.cls-313{fill:url(#linear-gradient-310);}.cls-314{fill:url(#linear-gradient-311);}.cls-315{fill:url(#linear-gradient-312);}.cls-316{fill:url(#linear-gradient-313);}.cls-317{fill:url(#linear-gradient-314);}.cls-318{fill:url(#linear-gradient-315);}.cls-319{fill:url(#linear-gradient-316);}.cls-320{fill:url(#linear-gradient-317);}.cls-321{fill:url(#linear-gradient-318);}.cls-322{fill:url(#linear-gradient-319);}.cls-323{fill:url(#linear-gradient-320);}.cls-324{fill:url(#linear-gradient-321);}.cls-325{fill:url(#linear-gradient-322);}.cls-326{fill:url(#linear-gradient-323);}.cls-327{fill:url(#linear-gradient-324);}.cls-328{fill:url(#linear-gradient-325);}.cls-329{fill:url(#linear-gradient-326);}.cls-330{fill:url(#linear-gradient-327);}.cls-331{fill:url(#linear-gradient-328);}.cls-332{fill:url(#linear-gradient-329);}.cls-333{fill:url(#linear-gradient-330);}.cls-334{fill:url(#linear-gradient-331);}.cls-335{fill:url(#linear-gradient-332);}.cls-336{fill:url(#linear-gradient-333);}.cls-337{fill:url(#linear-gradient-334);}.cls-338{fill:url(#linear-gradient-335);}.cls-339{fill:url(#linear-gradient-336);}.cls-340{fill:url(#linear-gradient-337);}.cls-341{fill:url(#linear-gradient-338);}.cls-342{fill:url(#linear-gradient-339);}.cls-343{fill:url(#linear-gradient-340);}.cls-344{fill:url(#linear-gradient-341);}.cls-345{fill:url(#linear-gradient-342);}.cls-346{fill:url(#linear-gradient-343);}.cls-347{fill:url(#linear-gradient-344);}.cls-348{fill:url(#linear-gradient-345);}.cls-349{fill:url(#linear-gradient-346);}.cls-350{fill:url(#linear-gradient-347);}.cls-351{fill:url(#linear-gradient-348);}.cls-352{fill:url(#linear-gradient-349);}.cls-353{fill:url(#linear-gradient-350);}.cls-354{fill:url(#linear-gradient-351);}.cls-355{fill:url(#linear-gradient-352);}.cls-356{fill:url(#linear-gradient-353);}.cls-357{fill:url(#linear-gradient-354);}.cls-358{fill:url(#linear-gradient-355);}.cls-359{fill:url(#linear-gradient-356);}.cls-360{fill:url(#linear-gradient-357);}.cls-361{fill:url(#linear-gradient-358);}.cls-362{fill:url(#linear-gradient-359);}.cls-363{fill:url(#linear-gradient-360);}.cls-364{fill:url(#linear-gradient-361);}.cls-365{fill:url(#linear-gradient-362);}.cls-366{fill:url(#linear-gradient-363);}.cls-367{fill:url(#linear-gradient-364);}.cls-368{fill:url(#linear-gradient-365);}.cls-369{fill:url(#linear-gradient-366);}.cls-370{fill:url(#linear-gradient-367);}.cls-371{fill:url(#linear-gradient-368);}.cls-372{fill:url(#linear-gradient-369);}.cls-373{fill:url(#linear-gradient-370);}.cls-374{fill:url(#linear-gradient-371);}.cls-375{fill:url(#linear-gradient-372);}.cls-376{fill:url(#linear-gradient-373);}.cls-377{fill:url(#linear-gradient-374);}.cls-378{fill:url(#linear-gradient-375);}.cls-379{fill:url(#linear-gradient-376);}.cls-380{fill:url(#linear-gradient-377);}.cls-381{fill:url(#linear-gradient-378);}.cls-382{fill:url(#linear-gradient-379);}.cls-383{fill:url(#linear-gradient-380);}.cls-384{fill:url(#linear-gradient-381);}.cls-385{fill:url(#linear-gradient-382);}.cls-386{fill:url(#linear-gradient-383);}.cls-387{fill:url(#linear-gradient-384);}.cls-388{fill:url(#linear-gradient-385);}.cls-389{opacity:0.67;fill:url(#linear-gradient-386);}.cls-390{fill:url(#linear-gradient-387);}.cls-391{fill:url(#radial-gradient);}.cls-392{fill:url(#linear-gradient-388);}.cls-393{fill:url(#radial-gradient-2);}.cls-394{fill:url(#radial-gradient-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -100.64,
    width: 389,
    height: 844
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 195,
    y1: -100.64,
    x2: 195,
    y2: 119.36,
    gradientTransform: "translate(0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a56a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c101f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 263.41,
    y1: 230.69,
    x2: 276.49,
    y2: 230.69,
    gradientTransform: "translate(0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c101e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20294f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 275.72,
    y1: 227.21,
    x2: 281.45,
    y2: 227.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 249.31,
    y1: 230.43,
    x2: 254.85,
    y2: 230.43,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 243.36,
    y1: 227.21,
    x2: 249.1,
    y2: 227.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 295.77,
    y1: 201.03,
    x2: 314.02,
    y2: 201.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 308.08,
    y1: 194.7,
    x2: 313.81,
    y2: 194.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 292.61,
    y1: 211.24,
    x2: 306.07,
    y2: 211.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 292.08,
    y1: 211.93,
    x2: 297.82,
    y2: 211.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 263.41,
    y1: 201.03,
    x2: 287.21,
    y2: 201.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 275.72,
    y1: 194.7,
    x2: 281.45,
    y2: 194.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 274.41,
    y1: 212.02,
    x2: 291.07,
    y2: 212.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 282.49,
    y1: 217.2,
    x2: 288.22,
    y2: 217.2,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 260.25,
    y1: 213.04,
    x2: 275.81,
    y2: 213.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 259.72,
    y1: 211.88,
    x2: 265.46,
    y2: 211.88,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 231.06,
    y1: 201.03,
    x2: 254.86,
    y2: 201.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 243.36,
    y1: 194.7,
    x2: 249.1,
    y2: 194.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 242.05,
    y1: 212.02,
    x2: 258.71,
    y2: 212.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 250.13,
    y1: 217.2,
    x2: 255.86,
    y2: 217.2,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 227.88,
    y1: 213.09,
    x2: 243.45,
    y2: 213.09,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 227.37,
    y1: 211.94,
    x2: 233.1,
    y2: 211.94,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 213.17,
    y1: 201.18,
    x2: 222.49,
    y2: 201.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 203.21,
    y1: 197.12,
    x2: 211.77,
    y2: 197.12,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 211,
    y1: 194.7,
    x2: 216.74,
    y2: 194.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 214.22,
    y1: 206.87,
    x2: 226.34,
    y2: 206.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 328.13,
    y1: 167.25,
    x2: 341.2,
    y2: 167.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 324.97,
    y1: 173.94,
    x2: 336.38,
    y2: 173.94,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 324.44,
    y1: 179.42,
    x2: 329.81,
    y2: 179.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 295.77,
    y1: 168.52,
    x2: 319.57,
    y2: 168.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 308.08,
    y1: 162.18,
    x2: 313.81,
    y2: 162.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 306.77,
    y1: 179.54,
    x2: 323.43,
    y2: 179.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 314.84,
    y1: 184.68,
    x2: 320.58,
    y2: 184.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 292.61,
    y1: 180.56,
    x2: 308.17,
    y2: 180.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 292.08,
    y1: 179.41,
    x2: 297.82,
    y2: 179.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 263.41,
    y1: 168.52,
    x2: 287.21,
    y2: 168.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 275.72,
    y1: 162.18,
    x2: 281.45,
    y2: 162.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 274.41,
    y1: 179.54,
    x2: 291.07,
    y2: 179.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 282.49,
    y1: 184.69,
    x2: 288.22,
    y2: 184.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 260.25,
    y1: 180.54,
    x2: 275.81,
    y2: 180.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 259.72,
    y1: 179.41,
    x2: 265.46,
    y2: 179.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 231.06,
    y1: 168.52,
    x2: 254.85,
    y2: 168.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 243.36,
    y1: 162.18,
    x2: 249.1,
    y2: 162.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 242.05,
    y1: 179.54,
    x2: 258.71,
    y2: 179.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 250.13,
    y1: 184.73,
    x2: 255.86,
    y2: 184.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 227.89,
    y1: 180.56,
    x2: 243.45,
    y2: 180.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 227.37,
    y1: 179.39,
    x2: 233.1,
    y2: 179.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 198.7,
    y1: 168.52,
    x2: 222.49,
    y2: 168.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 211,
    y1: 162.18,
    x2: 216.74,
    y2: 162.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 209.7,
    y1: 179.51,
    x2: 226.36,
    y2: 179.51,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 217.77,
    y1: 184.72,
    x2: 223.5,
    y2: 184.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 195.54,
    y1: 180.56,
    x2: 211.09,
    y2: 180.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 195.01,
    y1: 179.4,
    x2: 200.74,
    y2: 179.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 180.81,
    y1: 167.05,
    x2: 190.13,
    y2: 167.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 178.65,
    y1: 162.18,
    x2: 184.38,
    y2: 162.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 181.87,
    y1: 172.69,
    x2: 193.99,
    y2: 172.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 328.13,
    y1: 136.01,
    x2: 346.38,
    y2: 136.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 340.44,
    y1: 129.67,
    x2: 346.17,
    y2: 129.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 339.13,
    y1: 147.81,
    x2: 343.65,
    y2: 147.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 324.97,
    y1: 148.05,
    x2: 340.54,
    y2: 148.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 324.44,
    y1: 146.91,
    x2: 330.18,
    y2: 146.91,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 295.77,
    y1: 136.01,
    x2: 319.57,
    y2: 136.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 308.08,
    y1: 129.67,
    x2: 313.81,
    y2: 129.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 306.77,
    y1: 147.03,
    x2: 323.43,
    y2: 147.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 314.84,
    y1: 152.19,
    x2: 320.58,
    y2: 152.19,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 292.61,
    y1: 148.05,
    x2: 308.17,
    y2: 148.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 292.08,
    y1: 146.9,
    x2: 297.82,
    y2: 146.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 263.41,
    y1: 136.01,
    x2: 287.21,
    y2: 136.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 275.72,
    y1: 129.67,
    x2: 281.45,
    y2: 129.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 274.41,
    y1: 147.03,
    x2: 291.07,
    y2: 147.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 282.49,
    y1: 152.18,
    x2: 288.22,
    y2: 152.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 260.25,
    y1: 148.05,
    x2: 275.81,
    y2: 148.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 259.72,
    y1: 146.9,
    x2: 265.46,
    y2: 146.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 231.06,
    y1: 136.01,
    x2: 254.85,
    y2: 136.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 243.36,
    y1: 129.67,
    x2: 249.1,
    y2: 129.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 242.05,
    y1: 147.03,
    x2: 258.71,
    y2: 147.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 250.13,
    y1: 152.19,
    x2: 255.86,
    y2: 152.19,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 227.89,
    y1: 148.05,
    x2: 243.45,
    y2: 148.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 227.37,
    y1: 146.9,
    x2: 233.1,
    y2: 146.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 198.7,
    y1: 136.01,
    x2: 222.49,
    y2: 136.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 211,
    y1: 129.67,
    x2: 216.74,
    y2: 129.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 209.7,
    y1: 147.03,
    x2: 226.36,
    y2: 147.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 217.77,
    y1: 152.18,
    x2: 223.5,
    y2: 152.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 195.54,
    y1: 148.05,
    x2: 211.09,
    y2: 148.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 195.01,
    y1: 146.9,
    x2: 200.74,
    y2: 146.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 166.34,
    y1: 136.01,
    x2: 190.13,
    y2: 136.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 178.65,
    y1: 129.67,
    x2: 184.38,
    y2: 129.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 177.34,
    y1: 147.03,
    x2: 194,
    y2: 147.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 185.41,
    y1: 152.24,
    x2: 191.14,
    y2: 152.24,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 163.18,
    y1: 148.06,
    x2: 178.75,
    y2: 148.06,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 162.65,
    y1: 146.93,
    x2: 168.38,
    y2: 146.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 133.98,
    y1: 136.03,
    x2: 157.77,
    y2: 136.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 133.98,
    y1: 136.67,
    x2: 145.56,
    y2: 136.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 146.29,
    y1: 129.67,
    x2: 152.02,
    y2: 129.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 149.5,
    y1: 141.85,
    x2: 161.62,
    y2: 141.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 4.52,
    y1: 136.02,
    x2: 28.32,
    y2: 136.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 16.85,
    y1: 129.68,
    x2: 22.58,
    y2: 129.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1.38,
    y1: 147.57,
    x2: 16.95,
    y2: 147.57,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 0.85,
    y1: 146.96,
    x2: 6.59,
    y2: 146.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 360.49,
    y1: 102.23,
    x2: 384.28,
    y2: 102.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 372.8,
    y1: 97.16,
    x2: 378.53,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 376.02,
    y1: 107.26,
    x2: 388.16,
    y2: 107.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 357.33,
    y1: 109.2,
    x2: 370.79,
    y2: 109.2,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 356.8,
    y1: 114.39,
    x2: 362.54,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 328.13,
    y1: 103.49,
    x2: 351.92,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 340.44,
    y1: 97.16,
    x2: 346.17,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 339.14,
    y1: 114.5,
    x2: 355.8,
    y2: 114.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 347.2,
    y1: 119.69,
    x2: 352.94,
    y2: 119.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 324.97,
    y1: 115.54,
    x2: 340.53,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 324.44,
    y1: 114.39,
    x2: 330.18,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 295.77,
    y1: 103.49,
    x2: 319.57,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 308.08,
    y1: 97.16,
    x2: 313.81,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 306.77,
    y1: 114.5,
    x2: 323.43,
    y2: 114.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 314.84,
    y1: 119.67,
    x2: 320.58,
    y2: 119.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 292.61,
    y1: 115.54,
    x2: 308.17,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 292.08,
    y1: 114.39,
    x2: 297.82,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 263.41,
    y1: 103.49,
    x2: 287.21,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 275.72,
    y1: 97.16,
    x2: 281.45,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 274.41,
    y1: 114.5,
    x2: 291.07,
    y2: 114.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 282.49,
    y1: 119.69,
    x2: 288.22,
    y2: 119.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 260.25,
    y1: 115.54,
    x2: 275.81,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 259.72,
    y1: 114.39,
    x2: 265.46,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 231.06,
    y1: 103.49,
    x2: 254.85,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 243.36,
    y1: 97.16,
    x2: 249.1,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 242.05,
    y1: 114.5,
    x2: 258.71,
    y2: 114.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 250.13,
    y1: 119.68,
    x2: 255.86,
    y2: 119.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 227.89,
    y1: 115.54,
    x2: 243.45,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 227.37,
    y1: 114.39,
    x2: 233.1,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 198.7,
    y1: 103.49,
    x2: 222.49,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 211,
    y1: 97.16,
    x2: 216.74,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 209.7,
    y1: 114.5,
    x2: 226.37,
    y2: 114.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 217.77,
    y1: 119.67,
    x2: 223.5,
    y2: 119.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 195.54,
    y1: 115.54,
    x2: 211.09,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 195.01,
    y1: 114.39,
    x2: 200.74,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 166.34,
    y1: 103.49,
    x2: 190.13,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 178.65,
    y1: 97.16,
    x2: 184.38,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 177.34,
    y1: 114.5,
    x2: 194,
    y2: 114.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 185.41,
    y1: 119.66,
    x2: 191.14,
    y2: 119.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 163.18,
    y1: 115.54,
    x2: 178.75,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 162.65,
    y1: 114.38,
    x2: 168.38,
    y2: 114.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 133.98,
    y1: 103.49,
    x2: 157.77,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 146.29,
    y1: 97.16,
    x2: 152.02,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 144.98,
    y1: 114.5,
    x2: 161.64,
    y2: 114.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 153.05,
    y1: 119.66,
    x2: 158.78,
    y2: 119.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 130.82,
    y1: 115.54,
    x2: 146.39,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 130.29,
    y1: 114.39,
    x2: 136.02,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 101.62,
    y1: 103.49,
    x2: 125.41,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 113.93,
    y1: 97.16,
    x2: 119.66,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 112.61,
    y1: 111.68,
    x2: 129.28,
    y2: 111.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 121.13,
    y1: 118.97,
    x2: 126.43,
    y2: 118.97,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 98.46,
    y1: 115.05,
    x2: 114.03,
    y2: 115.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 97.93,
    y1: 114.39,
    x2: 103.66,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 69.26,
    y1: 103.49,
    x2: 93.05,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 81.57,
    y1: 97.16,
    x2: 87.3,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 80.26,
    y1: 111.22,
    x2: 96.91,
    y2: 111.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 66.1,
    y1: 115.05,
    x2: 81.67,
    y2: 115.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 65.57,
    y1: 114.39,
    x2: 71.31,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 36.9,
    y1: 103.49,
    x2: 60.7,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 49.21,
    y1: 97.16,
    x2: 54.94,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 47.9,
    y1: 112.77,
    x2: 64.56,
    y2: 112.77,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 33.74,
    y1: 115.54,
    x2: 49.3,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 33.22,
    y1: 114.39,
    x2: 38.96,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 4.52,
    y1: 103.49,
    x2: 28.32,
    y2: 103.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 16.85,
    y1: 97.16,
    x2: 22.58,
    y2: 97.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 15.54,
    y1: 114.5,
    x2: 32.2,
    y2: 114.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 23.62,
    y1: 119.68,
    x2: 29.35,
    y2: 119.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 1.38,
    y1: 115.54,
    x2: 16.94,
    y2: 115.54,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 0.85,
    y1: 114.39,
    x2: 6.59,
    y2: 114.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 360.49,
    y1: 70.98,
    x2: 384.28,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 372.8,
    y1: 64.65,
    x2: 378.53,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 371.49,
    y1: 81.98,
    x2: 388.16,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 379.56,
    y1: 87.15,
    x2: 385.3,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 357.33,
    y1: 83.04,
    x2: 372.9,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 356.8,
    y1: 81.85,
    x2: 362.54,
    y2: 81.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 328.13,
    y1: 70.98,
    x2: 351.92,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 340.44,
    y1: 64.65,
    x2: 346.17,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 339.14,
    y1: 81.98,
    x2: 355.8,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 347.2,
    y1: 87.15,
    x2: 352.94,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 324.97,
    y1: 83.04,
    x2: 340.53,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 324.44,
    y1: 81.84,
    x2: 330.18,
    y2: 81.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 295.77,
    y1: 70.98,
    x2: 319.57,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 308.08,
    y1: 64.65,
    x2: 313.81,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 306.77,
    y1: 81.98,
    x2: 323.43,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 314.84,
    y1: 87.15,
    x2: 320.58,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 292.61,
    y1: 83.04,
    x2: 308.17,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 292.08,
    y1: 81.85,
    x2: 297.82,
    y2: 81.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 263.41,
    y1: 70.98,
    x2: 287.21,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 275.72,
    y1: 64.65,
    x2: 281.45,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 274.41,
    y1: 81.98,
    x2: 291.07,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 282.49,
    y1: 87.15,
    x2: 288.22,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 260.25,
    y1: 83.04,
    x2: 275.81,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 259.72,
    y1: 81.81,
    x2: 265.46,
    y2: 81.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 231.06,
    y1: 70.98,
    x2: 254.85,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 243.36,
    y1: 64.65,
    x2: 249.1,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 242.05,
    y1: 81.98,
    x2: 258.71,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 250.13,
    y1: 87.15,
    x2: 255.86,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 227.89,
    y1: 83.04,
    x2: 243.45,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 227.37,
    y1: 81.85,
    x2: 233.1,
    y2: 81.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 198.7,
    y1: 70.98,
    x2: 222.49,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 211,
    y1: 64.65,
    x2: 216.74,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 209.7,
    y1: 81.98,
    x2: 226.36,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 217.77,
    y1: 87.15,
    x2: 223.5,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 195.54,
    y1: 83.04,
    x2: 211.09,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 195.01,
    y1: 81.85,
    x2: 200.74,
    y2: 81.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 166.34,
    y1: 70.98,
    x2: 190.13,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 178.65,
    y1: 64.65,
    x2: 184.38,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 177.34,
    y1: 81.98,
    x2: 194,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 185.41,
    y1: 87.13,
    x2: 191.14,
    y2: 87.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 163.18,
    y1: 83.04,
    x2: 178.75,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 162.65,
    y1: 81.84,
    x2: 168.38,
    y2: 81.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 133.98,
    y1: 70.98,
    x2: 157.77,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 146.29,
    y1: 64.65,
    x2: 152.02,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 144.98,
    y1: 81.98,
    x2: 161.65,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 153.05,
    y1: 87.15,
    x2: 158.78,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 130.82,
    y1: 83.04,
    x2: 146.39,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 130.29,
    y1: 81.85,
    x2: 136.02,
    y2: 81.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 101.62,
    y1: 70.98,
    x2: 125.41,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 113.93,
    y1: 64.65,
    x2: 119.66,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 112.61,
    y1: 81.98,
    x2: 129.29,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 120.69,
    y1: 87.17,
    x2: 126.43,
    y2: 87.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 98.46,
    y1: 83.04,
    x2: 114.03,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 97.93,
    y1: 81.85,
    x2: 103.66,
    y2: 81.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 69.26,
    y1: 70.98,
    x2: 93.05,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 81.57,
    y1: 64.65,
    x2: 87.3,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 80.27,
    y1: 81.98,
    x2: 96.93,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 88.33,
    y1: 87.15,
    x2: 94.07,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 66.1,
    y1: 83.04,
    x2: 81.66,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 65.57,
    y1: 81.85,
    x2: 71.31,
    y2: 81.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 36.9,
    y1: 70.98,
    x2: 60.7,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 49.21,
    y1: 64.65,
    x2: 54.94,
    y2: 64.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 47.9,
    y1: 81.98,
    x2: 64.56,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 55.97,
    y1: 87.15,
    x2: 61.71,
    y2: 87.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 33.74,
    y1: 83.04,
    x2: 49.3,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 33.22,
    y1: 81.85,
    x2: 38.96,
    y2: 81.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 4.52,
    y1: 70.98,
    x2: 28.32,
    y2: 70.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 16.85,
    y1: 64.66,
    x2: 22.58,
    y2: 64.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 15.54,
    y1: 81.98,
    x2: 32.2,
    y2: 81.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 23.62,
    y1: 87.17,
    x2: 29.35,
    y2: 87.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 1.38,
    y1: 83.04,
    x2: 16.94,
    y2: 83.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 0.85,
    y1: 81.81,
    x2: 6.59,
    y2: 81.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 360.49,
    y1: 38.47,
    x2: 384.28,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 372.8,
    y1: 32.13,
    x2: 378.53,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 371.49,
    y1: 49.49,
    x2: 388.16,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 379.56,
    y1: 54.64,
    x2: 385.3,
    y2: 54.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 357.33,
    y1: 50.53,
    x2: 372.9,
    y2: 50.53,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 356.8,
    y1: 49.37,
    x2: 362.54,
    y2: 49.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 328.13,
    y1: 38.47,
    x2: 351.92,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 340.44,
    y1: 32.13,
    x2: 346.17,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 339.14,
    y1: 49.49,
    x2: 355.8,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 347.2,
    y1: 54.64,
    x2: 352.94,
    y2: 54.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 324.97,
    y1: 50.5,
    x2: 340.53,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 324.44,
    y1: 49.36,
    x2: 330.18,
    y2: 49.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 295.77,
    y1: 38.47,
    x2: 319.57,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 308.08,
    y1: 32.13,
    x2: 313.81,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 306.77,
    y1: 49.49,
    x2: 323.43,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 314.84,
    y1: 54.63,
    x2: 320.58,
    y2: 54.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 292.61,
    y1: 50.5,
    x2: 308.17,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 292.08,
    y1: 49.36,
    x2: 297.82,
    y2: 49.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 263.41,
    y1: 38.47,
    x2: 287.21,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 275.72,
    y1: 32.13,
    x2: 281.45,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 274.41,
    y1: 49.49,
    x2: 291.07,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 282.49,
    y1: 54.64,
    x2: 288.22,
    y2: 54.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 260.25,
    y1: 50.53,
    x2: 275.81,
    y2: 50.53,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 259.72,
    y1: 49.28,
    x2: 265.46,
    y2: 49.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 231.06,
    y1: 38.47,
    x2: 254.85,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 243.36,
    y1: 32.13,
    x2: 249.1,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 242.05,
    y1: 49.49,
    x2: 258.71,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 250.13,
    y1: 54.65,
    x2: 255.86,
    y2: 54.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 227.89,
    y1: 50.5,
    x2: 243.45,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 227.37,
    y1: 49.36,
    x2: 233.1,
    y2: 49.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 198.7,
    y1: 38.47,
    x2: 222.49,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 211,
    y1: 32.13,
    x2: 216.74,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 209.7,
    y1: 49.49,
    x2: 226.37,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 217.77,
    y1: 54.64,
    x2: 223.5,
    y2: 54.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 195.54,
    y1: 50.5,
    x2: 211.09,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 195.01,
    y1: 49.36,
    x2: 200.74,
    y2: 49.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 166.34,
    y1: 38.47,
    x2: 190.13,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 178.65,
    y1: 32.13,
    x2: 184.38,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 177.34,
    y1: 49.49,
    x2: 194,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 185.41,
    y1: 54.64,
    x2: 191.14,
    y2: 54.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 163.18,
    y1: 50.5,
    x2: 178.75,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 162.65,
    y1: 49.36,
    x2: 168.38,
    y2: 49.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 133.98,
    y1: 38.47,
    x2: 157.77,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 146.29,
    y1: 32.13,
    x2: 152.02,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 144.98,
    y1: 49.49,
    x2: 161.64,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 153.05,
    y1: 54.68,
    x2: 158.78,
    y2: 54.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 130.82,
    y1: 50.5,
    x2: 146.39,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: 130.29,
    y1: 49.36,
    x2: 136.02,
    y2: 49.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: 101.62,
    y1: 38.47,
    x2: 125.41,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: 113.93,
    y1: 32.13,
    x2: 119.66,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: 112.61,
    y1: 49.49,
    x2: 129.29,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: 120.69,
    y1: 54.63,
    x2: 126.43,
    y2: 54.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: 98.46,
    y1: 50.5,
    x2: 114.03,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: 97.93,
    y1: 49.37,
    x2: 103.66,
    y2: 49.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: 69.26,
    y1: 38.47,
    x2: 93.05,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: 81.57,
    y1: 32.13,
    x2: 87.3,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: 80.27,
    y1: 49.49,
    x2: 96.93,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: 88.33,
    y1: 54.63,
    x2: 94.07,
    y2: 54.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: 66.1,
    y1: 50.5,
    x2: 81.66,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: 65.57,
    y1: 49.37,
    x2: 71.31,
    y2: 49.37,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 36.9,
    y1: 38.47,
    x2: 60.7,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: 49.21,
    y1: 32.13,
    x2: 54.94,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: 47.9,
    y1: 49.49,
    x2: 64.56,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: 55.97,
    y1: 54.65,
    x2: 61.71,
    y2: 54.65,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: 33.74,
    y1: 50.51,
    x2: 49.3,
    y2: 50.51,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    x1: 33.22,
    y1: 49.36,
    x2: 38.96,
    y2: 49.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    x1: 4.52,
    y1: 38.47,
    x2: 28.32,
    y2: 38.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    x1: 16.85,
    y1: 32.13,
    x2: 22.58,
    y2: 32.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    x1: 15.54,
    y1: 49.49,
    x2: 32.2,
    y2: 49.49,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    x1: 23.62,
    y1: 54.64,
    x2: 29.35,
    y2: 54.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: 1.38,
    y1: 50.5,
    x2: 16.94,
    y2: 50.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: 0.85,
    y1: 49.28,
    x2: 6.59,
    y2: 49.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    x1: 360.49,
    y1: 5.96,
    x2: 384.28,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    x1: 372.8,
    y1: -0.38,
    x2: 378.53,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    x1: 371.49,
    y1: 16.96,
    x2: 388.16,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: 379.56,
    y1: 22.12,
    x2: 385.3,
    y2: 22.12,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: 357.33,
    y1: 18.05,
    x2: 372.9,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: 356.8,
    y1: 16.87,
    x2: 362.53,
    y2: 16.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: 328.13,
    y1: 5.96,
    x2: 351.92,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: 340.44,
    y1: -0.38,
    x2: 346.17,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: 339.14,
    y1: 16.96,
    x2: 355.8,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: 347.2,
    y1: 22.14,
    x2: 352.94,
    y2: 22.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: 324.97,
    y1: 18.05,
    x2: 340.53,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: 324.44,
    y1: 16.86,
    x2: 330.18,
    y2: 16.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: 295.77,
    y1: 5.96,
    x2: 319.57,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: 308.08,
    y1: -0.38,
    x2: 313.81,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: 306.77,
    y1: 16.96,
    x2: 323.43,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: 314.84,
    y1: 22.13,
    x2: 320.58,
    y2: 22.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: 292.61,
    y1: 18.05,
    x2: 308.17,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: 292.08,
    y1: 16.85,
    x2: 297.82,
    y2: 16.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: 263.41,
    y1: 5.96,
    x2: 287.21,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: 275.72,
    y1: -0.38,
    x2: 281.45,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: 274.41,
    y1: 16.96,
    x2: 291.07,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: 282.49,
    y1: 22.15,
    x2: 288.22,
    y2: 22.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: 260.25,
    y1: 18.05,
    x2: 275.81,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: 259.72,
    y1: 16.86,
    x2: 265.46,
    y2: 16.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: 231.06,
    y1: 5.96,
    x2: 254.85,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: 243.36,
    y1: -0.38,
    x2: 249.1,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: 242.05,
    y1: 16.96,
    x2: 258.71,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: 250.13,
    y1: 22.14,
    x2: 255.86,
    y2: 22.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: 227.89,
    y1: 18.05,
    x2: 243.45,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: 227.37,
    y1: 16.85,
    x2: 233.1,
    y2: 16.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    x1: 198.7,
    y1: 5.96,
    x2: 222.49,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    x1: 211,
    y1: -0.38,
    x2: 216.74,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    x1: 209.7,
    y1: 16.96,
    x2: 226.36,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-345",
    x1: 217.77,
    y1: 22.13,
    x2: 223.5,
    y2: 22.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-346",
    x1: 195.54,
    y1: 18.05,
    x2: 211.09,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-347",
    x1: 195.01,
    y1: 16.85,
    x2: 200.74,
    y2: 16.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-348",
    x1: 166.34,
    y1: 5.96,
    x2: 190.13,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-349",
    x1: 178.65,
    y1: -0.38,
    x2: 184.38,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-350",
    x1: 177.34,
    y1: 16.96,
    x2: 194,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-351",
    x1: 185.41,
    y1: 22.12,
    x2: 191.14,
    y2: 22.12,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-352",
    x1: 163.18,
    y1: 18.05,
    x2: 178.75,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-353",
    x1: 162.65,
    y1: 16.84,
    x2: 168.38,
    y2: 16.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-354",
    x1: 133.98,
    y1: 5.96,
    x2: 157.77,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-355",
    x1: 146.29,
    y1: -0.38,
    x2: 152.02,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-356",
    x1: 144.98,
    y1: 16.96,
    x2: 161.64,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-357",
    x1: 153.05,
    y1: 22.18,
    x2: 158.78,
    y2: 22.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-358",
    x1: 130.82,
    y1: 18.05,
    x2: 146.39,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-359",
    x1: 130.29,
    y1: 16.84,
    x2: 136.02,
    y2: 16.84,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-360",
    x1: 101.62,
    y1: 5.96,
    x2: 125.41,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-361",
    x1: 113.93,
    y1: -0.38,
    x2: 119.66,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-362",
    x1: 112.61,
    y1: 16.96,
    x2: 129.29,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-363",
    x1: 120.69,
    y1: 22.13,
    x2: 126.43,
    y2: 22.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-364",
    x1: 98.46,
    y1: 18.05,
    x2: 114.03,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-365",
    x1: 97.93,
    y1: 16.87,
    x2: 103.66,
    y2: 16.87,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-366",
    x1: 69.26,
    y1: 5.96,
    x2: 93.05,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-367",
    x1: 81.57,
    y1: -0.38,
    x2: 87.3,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-368",
    x1: 80.27,
    y1: 16.96,
    x2: 96.93,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-369",
    x1: 88.33,
    y1: 22.11,
    x2: 94.07,
    y2: 22.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-370",
    x1: 66.1,
    y1: 18.05,
    x2: 81.66,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-371",
    x1: 65.57,
    y1: 16.86,
    x2: 71.31,
    y2: 16.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-372",
    x1: 36.9,
    y1: 5.96,
    x2: 60.7,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-373",
    x1: 49.21,
    y1: -0.38,
    x2: 54.94,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-374",
    x1: 47.9,
    y1: 16.96,
    x2: 64.56,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-375",
    x1: 55.97,
    y1: 22.15,
    x2: 61.71,
    y2: 22.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-376",
    x1: 33.74,
    y1: 18.05,
    x2: 49.3,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-377",
    x1: 33.22,
    y1: 16.85,
    x2: 38.96,
    y2: 16.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-378",
    x1: 4.52,
    y1: 5.96,
    x2: 28.32,
    y2: 5.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-379",
    x1: 16.85,
    y1: -0.38,
    x2: 22.58,
    y2: -0.38,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-380",
    x1: 15.54,
    y1: 16.96,
    x2: 32.2,
    y2: 16.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-381",
    x1: 23.62,
    y1: 22.15,
    x2: 29.35,
    y2: 22.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-382",
    x1: 1.38,
    y1: 18.05,
    x2: 16.94,
    y2: 18.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-383",
    x1: 0.85,
    y1: 16.89,
    x2: 6.59,
    y2: 16.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-384",
    x1: 316.18,
    y1: 175.22,
    x2: 388.88,
    y2: 91.45,
    gradientTransform: "translate(0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1c1e3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1e2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#232a52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2a3d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e5ba7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-385",
    x1: 263.37,
    y1: 172.86,
    x2: 458.05,
    y2: 31.13,
    xlinkHref: "#linear-gradient-384"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-386",
    x1: 263.37,
    y1: 172.86,
    x2: 458.05,
    y2: 31.13,
    gradientTransform: "translate(0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f9fcfe",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#e8f3fb",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#cfe6f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-387",
    x1: 72.85,
    y1: 180.28,
    x2: 342.81,
    y2: 151.3,
    gradientTransform: "translate(0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c101f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202a4f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -199.42,
    cy: -327.2,
    r: 1,
    gradientTransform: "translate(6571.73 10435.65) scale(31.35 31.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5d5f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c101f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-388",
    x1: -40.59,
    y1: 47.86,
    x2: 391.38,
    y2: 372.88,
    gradientTransform: "translate(0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c101f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a56a3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -202.44,
    cy: -330.61,
    r: 1,
    gradientTransform: "translate(11897.35 19359.17) scale(57.92 58.07)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -201.6,
    cy: -329.66,
    r: 1,
    gradientTransform: "translate(9703.54 15558.75) scale(46.87 46.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d41216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d11217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#c71418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b8161a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#a3171b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8a171b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6d1518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511014"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M390-100.64H0v275l30-54,41-35h39l61,35,73,61,45-12,60-75,41,9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M276.49,231.76c-2.53-2.71-5.7-4.74-8.56-4.17-4.46.84-4.52,6-4.52,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M278.59,230.09a2.87,2.87,0,0,0,2.89-2.86,2.24,2.24,0,0,0-.05-.58,2.89,2.89,0,0,0-4.85-1.49,3.16,3.16,0,0,0-.37.45,2.85,2.85,0,0,0-.49,1.6,2.77,2.77,0,0,0,.22,1.1,2.8,2.8,0,0,0,.62.94,2.88,2.88,0,0,0,2,.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M252.54,232.36c1-2.92,2.31-2.81,2.31-2.81-2.32-2.09-4-.82-5.54,1.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M246.23,230.09a2.87,2.87,0,0,0,2.89-2.86,2.24,2.24,0,0,0-.05-.58,2.87,2.87,0,0,0-.79-1.47,2.82,2.82,0,0,0-1.48-.79,2.89,2.89,0,0,0-3.49,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M314,198.71c-1.25,2-2.19,2.86-3.77,1.8a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M311,191.82a2.88,2.88,0,0,0-2.67,1.76,2.82,2.82,0,0,0-.18,1.67,2.93,2.93,0,0,0,.79,1.48,2.9,2.9,0,0,0,5-2,2.77,2.77,0,0,0-.22-1.1,2.89,2.89,0,0,0-.61-.93,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M305.27,210.25c2-4.25-.25-5.36-1.25-5.86a10.36,10.36,0,0,0-4-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.4,2.43a7.65,7.65,0,0,1-.4,1.84c-.85,2.71-1.17,5.55-.43,7.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M296.35,214.44a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.81,2.81,0,0,0,.72.85,3.16,3.16,0,0,0,1,.51,3,3,0,0,0,1.12.09A3.08,3.08,0,0,0,296.35,214.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M277.89,200.51a8.81,8.81,0,0,1-1.4-1.26c-2.53-2.71-5.7-4.74-8.56-4.17-4.46.84-4.52,6-4.52,6.29,3.46-5.75,8.91-.58,11.59,3.18s4.77,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,18.7,18.7,0,0,0,1.54-3.34c1-2.91,2.32-2.8,2.32-2.8-2.32-2.09-4-.82-5.55,1.69C280.41,200.7,279.48,201.57,277.89,200.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M278.59,191.82a2.88,2.88,0,0,0-2.67,1.76,2.82,2.82,0,0,0-.18,1.67,2.9,2.9,0,0,0,2.26,2.27,2.89,2.89,0,0,0,3.49-2.82,2.77,2.77,0,0,0-.22-1.1,2.89,2.89,0,0,0-.61-.93,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M287.78,200.74c3,6-4.24,7.89-8.83,8.17s-4.56,2.79-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.14,3.45,1.14,3.45,3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17a8.74,8.74,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,5.09,5.09,0,0,0,.46-.58,5.78,5.78,0,0,0,.64-1.17C292.35,203.68,288.05,200.92,287.78,200.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M283.83,219.65a2.88,2.88,0,0,0,3.17-.11,2.92,2.92,0,0,0,1-1.32,2.87,2.87,0,0,0-.71-3.09,2.87,2.87,0,0,0-1.48-.75,2.83,2.83,0,0,0-2.91,1.27,2.91,2.91,0,0,0-.38,2.19,2.87,2.87,0,0,0,.47,1A3,3,0,0,0,283.83,219.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M271.66,204.36a10.21,10.21,0,0,0-4.05-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a8.9,8.9,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.9-11.7S272.66,204.89,271.66,204.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M264,214.44a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.86,2.86,0,0,0,2.76,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M245.53,200.51a8.81,8.81,0,0,1-1.4-1.26c-2.53-2.71-5.7-4.74-8.56-4.17-4.46.84-4.52,6-4.51,6.29,3.45-5.75,8.91-.58,11.58,3.18s4.77,2.4,5.7,1.76a10.35,10.35,0,0,0,2.66-3.15,19.47,19.47,0,0,0,1.55-3.34c1-2.91,2.31-2.8,2.31-2.8-2.32-2.09-4-.82-5.54,1.69C248.05,200.7,247.12,201.57,245.53,200.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M246.23,191.82a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,0,0,3.76,3.77,2.73,2.73,0,0,0,1.29-1.06,2.88,2.88,0,0,0-2.38-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M255.42,200.74c3,6-4.23,7.89-8.82,8.17s-4.56,2.79-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,19,19,0,0,0,2,3.09c1.93,2.41,1.14,3.45,1.14,3.45,3-.86,2.79-2.93,1.52-5.61-1-2.13-1.26-3.39.48-4.17a8.74,8.74,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,6.51,6.51,0,0,0,.46-.58,5.78,5.78,0,0,0,.64-1.17C260,203.68,255.69,200.92,255.42,200.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M251.47,219.65a2.85,2.85,0,0,0,1.61.43,2.87,2.87,0,0,0,2.71-3.52,2.85,2.85,0,0,0-.82-1.45,2.9,2.9,0,0,0-1.49-.75,3,3,0,0,0-1.65.2,2.89,2.89,0,0,0-1.65,3.28,2.87,2.87,0,0,0,.47,1A3,3,0,0,0,251.47,219.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M235.78,221.08c2.91,3.5,7.39,1,7.67.88-6.67-.22-4.86-7.52-2.9-11.7s-.26-5.36-1.26-5.86a10.36,10.36,0,0,0-4-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3.05,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a8.9,8.9,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.42,7.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M227.73,213.36a3,3,0,0,0,1.2,1.15,2.91,2.91,0,0,0,1.64.28,2.81,2.81,0,0,0,2.42-2.07,2.87,2.87,0,0,0-2-3.54,2.54,2.54,0,0,0-.55-.1,2.88,2.88,0,0,0-3,2.09,2.82,2.82,0,0,0-.08,1.12A2.7,2.7,0,0,0,227.73,213.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M216,206.36a10.37,10.37,0,0,0,2.65-3.17,19.47,19.47,0,0,0,1.55-3.34c1-2.91,2.31-2.8,2.31-2.8-2.31-2.09-4-.82-5.54,1.69-1.26,2-2.19,2.86-3.78,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M211.77,199.25c-2.52-2.71-5.7-4.74-8.56-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M213.87,191.82a2.89,2.89,0,0,0-2.67,1.77,2.86,2.86,0,0,0,.62,3.14,2.89,2.89,0,0,0,3.18.63,2.73,2.73,0,0,0,1.29-1.06,2.88,2.88,0,0,0-2.42-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M217.91,213c2.77-.54,5.41-1.62,7-3.33a3.66,3.66,0,0,0,.46-.58,5.11,5.11,0,0,0,.64-1.17c1.66-4.24-2.64-7-2.91-7.18,3,6-4.24,7.89-8.83,8.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M341.2,166.74c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.83-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M336.38,171.88a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.68,3.05,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M329.81,178a3,3,0,0,0-1.2-1.15,3,3,0,0,0-1.64-.29,2.89,2.89,0,0,0-1.53.68,2.82,2.82,0,0,0-.89,1.4,2.71,2.71,0,0,0,1,3,2.88,2.88,0,0,0,3.17.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M310.25,168a8,8,0,0,1-1.41-1.25c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.83-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.17s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.8,2.32-2.8-2.31-2.09-3.95-.83-5.54,1.69C312.77,168.19,311.83,169.06,310.25,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M311,159.3a2.88,2.88,0,0,0-2.67,1.76,2.82,2.82,0,0,0-.18,1.67,2.89,2.89,0,0,0,.79,1.48,2.87,2.87,0,0,0,1.47.79,2.81,2.81,0,0,0,1.67-.16,2.73,2.73,0,0,0,1.29-1.06,2.85,2.85,0,0,0,.49-1.6,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M320.14,168.23c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.91a10.42,10.42,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.42,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.17,8.17,0,0,1,1.81-.53,13.18,13.18,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,5.82,5.82,0,0,0,.65-1.17C324.71,171.17,320.41,168.36,320.14,168.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M316.19,187.14a3,3,0,0,0,1.05.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,2.9,2.9,0,0,0-.82-.78,2.7,2.7,0,0,0-1.06-.41,3.07,3.07,0,0,0-1.13,0,2.87,2.87,0,0,0-1,.47,2.94,2.94,0,0,0-.77.84,2.84,2.84,0,0,0-.4,1.06,2.74,2.74,0,0,0,0,1.14,2.89,2.89,0,0,0,.48,1A3,3,0,0,0,316.19,187.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M304,171.88a10.36,10.36,0,0,0-4-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3.05,1.22,3.87,4.18,4,2.34.12,3.56.51,3.4,2.43A7.65,7.65,0,0,1,300,179c-.85,2.71-1.17,5.55-.43,7.73a5.28,5.28,0,0,0,.29.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.7S305,172.36,304,171.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M296.35,181.93a2.87,2.87,0,0,0,1.1-3.92,2.81,2.81,0,0,0-.72-.85,2.85,2.85,0,0,0-2.12-.61,3.08,3.08,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.81,2.81,0,0,0,1.72,1.37,3,3,0,0,0,1.12.09A3.08,3.08,0,0,0,296.35,181.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M277.89,168a8.3,8.3,0,0,1-1.4-1.25c-2.53-2.71-5.7-4.75-8.56-4.17-4.46.83-4.52,6-4.52,6.29,3.46-5.75,8.91-.59,11.59,3.17s4.77,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.8,2.32-2.8-2.32-2.09-4-.83-5.55,1.69C280.41,168.19,279.48,169.06,277.89,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M278.59,159.3A2.88,2.88,0,0,0,278,165a2.81,2.81,0,0,0,1.67-.16,2.73,2.73,0,0,0,1.29-1.06,2.85,2.85,0,0,0,.49-1.6,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M287.78,168.23c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.91a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.42,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.74,8.74,0,0,1,1.81-.53,13.16,13.16,0,0,0,7-3.33,3.6,3.6,0,0,0,.45-.58,5.56,5.56,0,0,0,.65-1.17C292.35,171.17,288.05,168.36,287.78,168.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M283.83,187.14a2.85,2.85,0,0,0,1.61.43,2.88,2.88,0,0,0,.4-5.72,2.92,2.92,0,0,0-1.65.21,2.84,2.84,0,0,0-1.27,1.08,2.91,2.91,0,0,0-.38,2.19,2.87,2.87,0,0,0,.47,1A3,3,0,0,0,283.83,187.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M271.66,171.88a10.21,10.21,0,0,0-4.05-.77,18.17,18.17,0,0,0-3.61.25c-3,.54-3.57-.65-3.57-.65-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.41,2.43a8.9,8.9,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.43,7.73a5.28,5.28,0,0,0,.29.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.9-11.7S272.66,172.36,271.66,171.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M264,181.93a2.88,2.88,0,1,0-3.65-4.31,2.8,2.8,0,0,0-.61,1.56,2.88,2.88,0,0,0,4.26,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M245.53,168a8.3,8.3,0,0,1-1.4-1.25c-2.53-2.71-5.7-4.75-8.56-4.17-4.46.83-4.52,6-4.51,6.29,3.45-5.75,8.91-.59,11.58,3.17s4.77,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.32-2.09-4-.83-5.54,1.69C248.05,168.19,247.12,169.06,245.53,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M246.23,159.3a2.94,2.94,0,0,0-1.6.48,2.81,2.81,0,0,0-1.07,1.29,2.88,2.88,0,1,0,5.54,1.14,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M255.42,168.23c3,6-4.23,7.9-8.82,8.18s-4.56,2.79-4.52,3.91a10.53,10.53,0,0,0,1.27,4,18.89,18.89,0,0,0,2,3.08c1.93,2.42,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.52-5.62-1-2.12-1.26-3.38.48-4.16a8.74,8.74,0,0,1,1.81-.53,13.16,13.16,0,0,0,7-3.33,6.51,6.51,0,0,0,.46-.58,5.78,5.78,0,0,0,.64-1.17C260,171.17,255.69,168.36,255.42,168.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M251.47,187.14a3,3,0,0,0,1.05.4,2.6,2.6,0,0,0,2.12-.46,3,3,0,0,0,.76-.82,2.85,2.85,0,0,0,.43-1.61,2.8,2.8,0,0,0-.53-1.58,2.87,2.87,0,0,0-3-1.12,2.74,2.74,0,0,0-1.44.83,2.81,2.81,0,0,0-.74,1.49,3,3,0,0,0,.22,1.66A2.87,2.87,0,0,0,251.47,187.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M239.3,171.88a10.21,10.21,0,0,0-4.05-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3.05,1.22,3.87,4.18,4,2.34.12,3.56.51,3.41,2.43a8.9,8.9,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.42,7.73a4.15,4.15,0,0,0,.28.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.67-.22-4.86-7.52-2.9-11.7S240.3,172.36,239.3,171.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M231.63,181.93a2.87,2.87,0,0,0-.6-5.29,2.83,2.83,0,0,0-1.68,0,2.87,2.87,0,0,0-2,2.51,2.88,2.88,0,0,0,4.26,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M213.17,168a8.3,8.3,0,0,1-1.4-1.25c-2.52-2.71-5.7-4.75-8.56-4.17-4.46.83-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.17s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.83-5.54,1.69C215.69,168.19,214.76,169.06,213.17,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M213.87,159.3a2.94,2.94,0,0,0-1.6.48,2.81,2.81,0,0,0-1.07,1.29,2.88,2.88,0,1,0,5.54,1.14,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M223.06,168.23c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.91a10.34,10.34,0,0,0,1.29,3.94,19.58,19.58,0,0,0,2,3.08c1.93,2.42,1.14,3.46,1.14,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.12-1.26-3.38.49-4.16a8.65,8.65,0,0,1,1.8-.53,13.12,13.12,0,0,0,7-3.33,4.34,4.34,0,0,0,.46-.58,5.11,5.11,0,0,0,.64-1.17C227.63,171.17,223.33,168.36,223.06,168.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M219.11,187.14a3.09,3.09,0,0,0,1,.4,2.6,2.6,0,0,0,2.12-.46,3,3,0,0,0,.76-.82,3,3,0,0,0,.41-1.06,2.69,2.69,0,0,0,0-1.13,2.85,2.85,0,0,0-.46-1,2.9,2.9,0,0,0-.82-.78,2.81,2.81,0,0,0-2.17-.36,2.85,2.85,0,0,0-1,.46,3,3,0,0,0-.76.82,3.07,3.07,0,0,0-.41,1,3.12,3.12,0,0,0,0,1.14,2.85,2.85,0,0,0,.46,1A3,3,0,0,0,219.11,187.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M206.94,171.88a10.21,10.21,0,0,0-4.05-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.69,3.05,1.21,3.87,4.17,4,2.35.12,3.56.51,3.41,2.43a7.67,7.67,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.42,7.73a5.24,5.24,0,0,0,.28.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.67-.22-4.86-7.52-2.9-11.7S207.94,172.36,206.94,171.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M195.37,180.82a3,3,0,0,0,1.2,1.15,2.91,2.91,0,0,0,1.64.28,2.87,2.87,0,0,0,.44-5.61,2.54,2.54,0,0,0-.55-.1,2.9,2.9,0,0,0-1.63.36,2.71,2.71,0,0,0-.85.73,3.18,3.18,0,0,0-.52,1,2.82,2.82,0,0,0-.08,1.12A2.7,2.7,0,0,0,195.37,180.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M186.27,170.64a19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.83-5.54,1.69-1.26,2-2.19,2.86-3.78,1.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M181.51,165.06a2.88,2.88,0,0,0,2.67-1.76,2.82,2.82,0,0,0,.18-1.67,2.9,2.9,0,0,0-2.26-2.27,2.81,2.81,0,0,0-1.67.16,2.73,2.73,0,0,0-1.29,1.06,2.85,2.85,0,0,0-.49,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M192.51,177.16a3.66,3.66,0,0,0,.46-.58,4.75,4.75,0,0,0,.64-1.17c1.66-4.24-2.63-7-2.91-7.18,3,6-4.24,7.9-8.83,8.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M346.38,133.68c-1.25,2-2.19,2.87-3.77,1.8a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M343.31,126.79a2.89,2.89,0,0,0-2.85,3.43,2.93,2.93,0,0,0,.79,1.48,2.89,2.89,0,1,0,2.12-4.91h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M343.65,143.88c-4.66.29-4.56,2.8-4.51,3.92a10.59,10.59,0,0,0,1.27,3.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M340.54,156.93c-6.68-.22-4.86-7.53-2.91-11.71s-.25-5.36-1.25-5.86a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.91,3.5,7.38,1,7.67.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M328.71,149.41a2.91,2.91,0,0,0,1.16-1.2,2.83,2.83,0,0,0,.29-1.64,2.89,2.89,0,0,0-2.07-2.43,3,3,0,0,0-1.67,0,2.89,2.89,0,0,0-1.36,1,2.74,2.74,0,0,0-.61,1.55,2.9,2.9,0,0,0,.36,1.63,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A2.9,2.9,0,0,0,328.71,149.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M310.25,135.48a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.8,2.32-2.8-2.31-2.09-3.95-.82-5.54,1.69C312.77,135.68,311.83,136.55,310.25,135.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M311,126.79a2.89,2.89,0,0,0-2.85,3.43,2.93,2.93,0,0,0,.79,1.48,2.9,2.9,0,0,0,5-2,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M320.14,135.72c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.51,3.92a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.17A8.15,8.15,0,0,1,315,148a13.25,13.25,0,0,0,7-3.33,3.74,3.74,0,0,0,.46-.59,4.92,4.92,0,0,0,.65-1.16C324.71,138.66,320.41,135.89,320.14,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M316.19,154.62a2.87,2.87,0,0,0,3.19-.09,3,3,0,0,0,.76-.82,2.94,2.94,0,0,0,.44-1.61,2.85,2.85,0,0,0-2.93-2.78,2.87,2.87,0,0,0-2.77,2.39,2.84,2.84,0,0,0,1.31,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M304,139.36a10.36,10.36,0,0,0-4-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.4,2.43a7.84,7.84,0,0,1-.4,1.85c-.85,2.7-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,5.25,5.25,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.87-6.68-.22-4.86-7.53-2.91-11.71S305,139.86,304,139.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M296.35,149.41a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,3,3,0,0,0-1.12-.09,3.08,3.08,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A3.08,3.08,0,0,0,296.35,149.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M277.89,135.48a8.36,8.36,0,0,1-1.4-1.26c-2.53-2.7-5.7-4.74-8.56-4.16-4.46.83-4.52,6-4.52,6.29,3.46-5.74,8.91-.58,11.59,3.18s4.77,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.8,2.32-2.8-2.32-2.09-4-.82-5.55,1.69C280.41,135.68,279.48,136.55,277.89,135.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M278.59,126.79a2.89,2.89,0,0,0-2.85,3.43,2.9,2.9,0,0,0,2.26,2.27,2.89,2.89,0,0,0,3.49-2.82,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M287.78,135.72c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.51,3.92a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.17a8.72,8.72,0,0,1,1.81-.52,13.31,13.31,0,0,0,7-3.33,3.68,3.68,0,0,0,.45-.59,4.92,4.92,0,0,0,.65-1.16C292.35,138.66,288.05,135.89,287.78,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M283.83,154.62a2.86,2.86,0,0,0,1.05.4,3,3,0,0,0,1.11,0,2.79,2.79,0,0,0,1.79-1.28,2.94,2.94,0,0,0,.44-1.61,2.86,2.86,0,0,0-2.9-2.84,2.56,2.56,0,0,0-.62.07,2.74,2.74,0,0,0-1.44.83,2.91,2.91,0,0,0,.57,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M271.66,139.36a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a9,9,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,5.25,5.25,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.87-6.68-.22-4.86-7.53-2.9-11.71S272.66,139.86,271.66,139.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M264,149.41a2.87,2.87,0,0,0,.79-4.37,2.86,2.86,0,0,0-1.41-.9,3,3,0,0,0-1.67,0,2.89,2.89,0,0,0-1.36,1,2.74,2.74,0,0,0-.61,1.55,2.87,2.87,0,0,0,4.26,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M245.53,135.48a7.3,7.3,0,0,1-1.4-1.26c-2.53-2.7-5.7-4.74-8.56-4.16-4.46.83-4.52,6-4.51,6.29,3.45-5.74,8.91-.58,11.58,3.18s4.77,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.32-2.09-4-.82-5.54,1.69C248.05,135.68,247.12,136.55,245.53,135.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M246.23,126.79a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M255.42,135.72c3,6-4.23,7.9-8.82,8.17s-4.56,2.8-4.52,3.92a10.53,10.53,0,0,0,1.27,4,18.89,18.89,0,0,0,2,3.08c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.52-5.62-1-2.12-1.26-3.38.48-4.17a8.72,8.72,0,0,1,1.81-.52,13.31,13.31,0,0,0,7-3.33,6.65,6.65,0,0,0,.46-.59,5.7,5.7,0,0,0,.64-1.16C260,138.66,255.69,135.89,255.42,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M251.47,154.62a2.73,2.73,0,0,0,1,.4,2.84,2.84,0,0,0,2.91-1.31,2.94,2.94,0,0,0,.44-1.61,2.87,2.87,0,0,0-2.95-2.78,2.78,2.78,0,0,0-.57.07,2.74,2.74,0,0,0-1.44.83,2.88,2.88,0,0,0-.53,3.14A3,3,0,0,0,251.47,154.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M239.3,139.36a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a9,9,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73a3.36,3.36,0,0,0,.28.68,5.25,5.25,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.87-6.67-.22-4.86-7.53-2.9-11.71S240.3,139.86,239.3,139.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M231.63,149.41a2.91,2.91,0,0,0,1.16-1.2,2.83,2.83,0,0,0,.29-1.64,2.89,2.89,0,0,0-2.07-2.43,3,3,0,0,0-1.67,0,2.89,2.89,0,0,0-1.36,1,2.74,2.74,0,0,0-.61,1.55,2.86,2.86,0,0,0,4.26,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M213.17,135.48a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.7-5.7-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.82-5.54,1.69C215.69,135.68,214.76,136.55,213.17,135.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M213.87,126.79a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M223.06,135.72c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.52,3.92a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.12-1.26-3.38.49-4.17a8.06,8.06,0,0,1,1.8-.52c2.77-.55,5.41-1.63,7-3.33a3.74,3.74,0,0,0,.46-.59A5.26,5.26,0,0,0,226,143C227.63,138.66,223.33,135.89,223.06,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M219.11,154.62a2.73,2.73,0,0,0,1,.4,2.84,2.84,0,0,0,2.91-1.31,2.94,2.94,0,0,0,.44-1.61,2.87,2.87,0,0,0-2.94-2.8,2.31,2.31,0,0,0-.52.06,2.74,2.74,0,0,0-1.44.83,2.86,2.86,0,0,0,.55,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M206.94,139.36a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.21,3.87,4.17,4,2.35.13,3.56.52,3.41,2.43a7.85,7.85,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73a4.43,4.43,0,0,0,.28.68,5.25,5.25,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.87-6.67-.22-4.86-7.53-2.9-11.71S207.94,139.86,206.94,139.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M199.28,149.41a2.9,2.9,0,0,0,1.46-2.85,2.87,2.87,0,0,0-3.17-2.53,3,3,0,0,0-.59.13,2.9,2.9,0,0,0-1.83,3.66,3.06,3.06,0,0,0,.22.49,2.87,2.87,0,0,0,3.91,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M180.81,135.48a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.7-5.7-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.82-5.54,1.69C183.33,135.68,182.4,136.55,180.81,135.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M181.51,126.79a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M190.7,135.72c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.52,3.92a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.12-1.26-3.38.49-4.17a8.06,8.06,0,0,1,1.8-.52c2.77-.55,5.41-1.63,7-3.33a3.74,3.74,0,0,0,.46-.59,4.88,4.88,0,0,0,.64-1.16C195.27,138.66,191,135.89,190.7,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M186.75,154.62a2.87,2.87,0,0,0,1.06.42,3.07,3.07,0,0,0,1.13,0,2.89,2.89,0,0,0,2.16-3.46,3,3,0,0,0-.46-1,2.92,2.92,0,0,0-1.32-1,2.87,2.87,0,0,0-2.57,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M171.06,156.06c2.91,3.5,7.39,1,7.67.87-6.68-.22-4.87-7.53-2.91-11.71s-.25-5.36-1.26-5.86a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.17,4,2.35.13,3.56.52,3.41,2.43a7.85,7.85,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M166.92,149.41a2.82,2.82,0,0,0,1.15-1.22,2.93,2.93,0,0,0,.28-1.65,3,3,0,0,0-.69-1.53,2.92,2.92,0,0,0-3.1-.83,3,3,0,0,0-1.36,1,2.91,2.91,0,0,0-.2,3.2,2.88,2.88,0,0,0,.74.85,2.75,2.75,0,0,0,1,.49,2.82,2.82,0,0,0,1.12.08A3.16,3.16,0,0,0,166.92,149.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M145.56,139.54c2.71,3.82,4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,17.69,17.69,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.82-5.54,1.69-1.26,2-2.19,2.87-3.77,1.8a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M134,136.36c3.46-5.74,8.91-.58,11.58,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M149.15,126.79a2.89,2.89,0,0,0-2.67,1.77A2.88,2.88,0,1,0,152,129.7a2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M153.19,148a13.16,13.16,0,0,0,7-3.33,4.44,4.44,0,0,0,.46-.59,4.88,4.88,0,0,0,.64-1.16c1.67-4.24-2.63-7-2.91-7.18,3,6-4.24,7.9-8.83,8.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M24.48,138.13A18.53,18.53,0,0,0,26,134.8c1-2.92,2.32-2.8,2.32-2.8-2.32-2.09-4-.82-5.55,1.69-1.25,2-2.18,2.87-3.77,1.8a7.3,7.3,0,0,1-1.4-1.26c-2.53-2.7-5.7-4.74-8.56-4.16-4.46.83-4.52,6-4.52,6.29,3.46-5.74,8.91-.58,11.59,3.18s4.77,2.4,5.7,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M19.72,126.79a3,3,0,0,0-1.61.47A3.09,3.09,0,0,0,17,128.55a2.88,2.88,0,0,0,2.09,3.94,2.78,2.78,0,0,0,1.71-.13,2.88,2.88,0,0,0-1.08-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M17,156.93c-6.68-.22-4.86-7.53-2.9-11.71s-.26-5.36-1.26-5.86a10.36,10.36,0,0,0-4-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a9,9,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.43,7.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M5.12,149.41a2.86,2.86,0,0,0-2.76-5,3,3,0,0,0-.86.74,2.64,2.64,0,0,0-.51,1,3,3,0,0,0-.09,1.12,2.8,2.8,0,0,0,.32,1.09,3.09,3.09,0,0,0,.73.84,2.75,2.75,0,0,0,1,.49A2.84,2.84,0,0,0,5.12,149.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M380.43,105.62a18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-3.95-.82-5.54,1.69-1.26,2-2.19,2.87-3.77,1.8a8.88,8.88,0,0,1-1.41-1.26C371,99,367.87,97,365,97.54c-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M375.66,94.28A2.89,2.89,0,0,0,373,96.05a2.88,2.88,0,1,0,5.54,1.14,2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M387.76,110.36c1.67-4.25-2.63-7-2.91-7.18,3,6-4.24,7.89-8.83,8.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M370,112.71c2-4.25-.25-5.36-1.25-5.86a10.29,10.29,0,0,0-4.06-.77,17.55,17.55,0,0,0-3.69.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M361.07,116.9a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0-.89,1.41,2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,.95,1.37,2.86,2.86,0,0,0,1.55.6A2.74,2.74,0,0,0,361.07,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M342.61,103a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-3.95-.82-5.54,1.69C345.13,103.16,344.19,104,342.61,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M343.31,94.28A2.88,2.88,0,0,0,340.64,96a2.82,2.82,0,0,0-.18,1.67,2.93,2.93,0,0,0,.79,1.48,2.89,2.89,0,1,0,2.12-4.91h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M352.49,103.21c3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.13,3.46,1.13,3.46,3-.85,2.79-2.93,1.51-5.61-1-2.13-1.25-3.38.49-4.17a8.17,8.17,0,0,1,1.81-.53c2.77-.54,5.4-1.62,6.95-3.33a3.66,3.66,0,0,0,.46-.58,5.74,5.74,0,0,0,.65-1.16C357.07,106.14,352.77,103.36,352.49,103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M348.55,122.11a2.86,2.86,0,0,0,1.05.4,3,3,0,0,0,1.11,0,2.79,2.79,0,0,0,1.79-1.28,2.91,2.91,0,0,0,.38-2.19,3,3,0,0,0-.46-1,3.24,3.24,0,0,0-.83-.78,2.73,2.73,0,0,0-1-.4,2.84,2.84,0,0,0-2.15.49,3,3,0,0,0-.76.82,2.91,2.91,0,0,0-.38,2.19,2.87,2.87,0,0,0,.47,1A2.93,2.93,0,0,0,348.55,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M336.38,106.85a10.29,10.29,0,0,0-4.06-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.17,5.54-.43,7.73a5.79,5.79,0,0,0,.29.68,5.25,5.25,0,0,0,.71,1.13c2.91,3.5,7.38,1,7.67.87-6.68-.22-4.86-7.52-2.91-11.7S337.38,107.36,336.38,106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M328.71,116.9a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.88,2.88,0,0,0,1.74,5.37A3.08,3.08,0,0,0,328.71,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M310.25,103a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.81,2.32-2.81-2.31-2.09-3.95-.82-5.54,1.69C312.77,103.16,311.83,104,310.25,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M311,94.28A2.88,2.88,0,0,0,308.33,96a2.82,2.82,0,0,0-.18,1.67,2.93,2.93,0,0,0,.79,1.48,2.9,2.9,0,0,0,5-2,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M320.14,103.21c3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.14,3.46,1.14,3.46,3-.85,2.79-2.93,1.51-5.61-1-2.13-1.25-3.38.49-4.17a8.17,8.17,0,0,1,1.81-.53,13.1,13.1,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,5.74,5.74,0,0,0,.65-1.16C324.71,106.14,320.41,103.36,320.14,103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M316.19,122.11a2.73,2.73,0,0,0,1,.4,2.61,2.61,0,0,0,2.13-.46,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,3,3,0,0,0-1.88-1.2,2.69,2.69,0,0,0-1.13,0,2.85,2.85,0,0,0-1,.46,2.94,2.94,0,0,0-.77.84,2.8,2.8,0,0,0,.12,3.2A3,3,0,0,0,316.19,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M304,106.85a10.36,10.36,0,0,0-4-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.4,2.43A7.84,7.84,0,0,1,300,114c-.85,2.7-1.17,5.54-.43,7.73a6.68,6.68,0,0,0,1,1.81c2.91,3.5,7.39,1,7.67.87-6.68-.22-4.86-7.52-2.91-11.7S305,107.36,304,106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M296.35,116.9a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.88,2.88,0,0,0,1.74,5.37A3.08,3.08,0,0,0,296.35,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M277.89,103a8.81,8.81,0,0,1-1.4-1.26C274,99,270.79,97,267.93,97.54c-4.46.84-4.52,6-4.52,6.29,3.46-5.74,8.91-.58,11.59,3.18s4.77,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.81,2.32-2.81-2.32-2.09-4-.82-5.55,1.69C280.41,103.16,279.48,104,277.89,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M278.59,94.28A2.88,2.88,0,0,0,275.92,96a2.82,2.82,0,0,0-.18,1.67A2.9,2.9,0,0,0,278,100a2.89,2.89,0,0,0,3.49-2.82,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M287.78,103.21c3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.14,3.46,1.14,3.46,3-.85,2.79-2.93,1.51-5.61-1-2.13-1.25-3.38.49-4.17a8.74,8.74,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,5.09,5.09,0,0,0,.46-.58,5.7,5.7,0,0,0,.64-1.16C292.35,106.14,288.05,103.36,287.78,103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M283.83,122.11a2.86,2.86,0,0,0,1.05.4,3,3,0,0,0,1.11,0,2.79,2.79,0,0,0,1.79-1.28,3.09,3.09,0,0,0,.41-2.19,3,3,0,0,0-.46-1,2.9,2.9,0,0,0-.83-.77,2.73,2.73,0,0,0-1-.4,2.84,2.84,0,0,0-2.15.49,3,3,0,0,0-.76.82,2.91,2.91,0,0,0-.38,2.19,2.87,2.87,0,0,0,.47,1A2.93,2.93,0,0,0,283.83,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M271.66,106.85a10.21,10.21,0,0,0-4.05-.77,17.47,17.47,0,0,0-3.61.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a9,9,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.43,7.73a6.68,6.68,0,0,0,1,1.81c2.91,3.5,7.39,1,7.67.87-6.68-.22-4.86-7.52-2.9-11.7S272.66,107.36,271.66,106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M264,116.9a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.88,2.88,0,0,0,1.74,5.37A3.08,3.08,0,0,0,264,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M245.53,103a8.81,8.81,0,0,1-1.4-1.26c-2.53-2.71-5.7-4.74-8.56-4.17-4.46.84-4.52,6-4.51,6.29,3.45-5.74,8.91-.58,11.58,3.18s4.77,2.4,5.7,1.76A10.37,10.37,0,0,0,251,105.6a19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.81,2.31-2.81-2.32-2.09-4-.82-5.54,1.69C248.05,103.16,247.12,104,245.53,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M246.23,94.28a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M255.42,103.21c3,6-4.23,7.89-8.82,8.17s-4.56,2.8-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,19,19,0,0,0,2,3.09c1.93,2.41,1.14,3.46,1.14,3.46,3-.85,2.79-2.93,1.52-5.61-1-2.13-1.26-3.38.48-4.17a8.74,8.74,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,5.09,5.09,0,0,0,.46-.58,5.7,5.7,0,0,0,.64-1.16C260,106.14,255.69,103.36,255.42,103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M251.47,122.11a2.73,2.73,0,0,0,1,.4,2.84,2.84,0,0,0,2.91-1.31,2.94,2.94,0,0,0,.44-1.61,2.87,2.87,0,0,0-2.95-2.78,2.78,2.78,0,0,0-.57.07,2.92,2.92,0,0,0-1.44.83,2.88,2.88,0,0,0-.53,3.14A3,3,0,0,0,251.47,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M239.3,106.85a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a9,9,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73a4.43,4.43,0,0,0,.28.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.87-6.67-.22-4.86-7.52-2.9-11.7S240.3,107.36,239.3,106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M231.63,116.9a2.85,2.85,0,0,0,1.45-2.84,2.8,2.8,0,0,0-.67-1.53,2.84,2.84,0,0,0-1.4-.9,3,3,0,0,0-1.67,0,2.89,2.89,0,0,0-1.36,1,2.74,2.74,0,0,0-.61,1.55,2.86,2.86,0,0,0,4.26,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M213.17,103a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.71-5.7-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C215.69,103.16,214.76,104,213.17,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M213.87,94.28a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M223.06,103.21c3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.93,2.41,1.14,3.46,1.14,3.46,3-.85,2.8-2.93,1.52-5.61-1-2.13-1.26-3.38.49-4.17a8.09,8.09,0,0,1,1.8-.53c2.77-.54,5.41-1.62,7-3.33a3.66,3.66,0,0,0,.46-.58,5.5,5.5,0,0,0,.61-1.21C227.63,106.14,223.33,103.36,223.06,103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M219.11,122.11a2.73,2.73,0,0,0,1,.4A2.84,2.84,0,0,0,223,121.2a3,3,0,0,0,.41-1.06,2.69,2.69,0,0,0,0-1.13,2.85,2.85,0,0,0-.46-1,2.9,2.9,0,0,0-.82-.78,2.73,2.73,0,0,0-1-.4,2.84,2.84,0,0,0-2.15.49,3,3,0,0,0-.76.82,3.07,3.07,0,0,0-.41,1,3.12,3.12,0,0,0,0,1.14,2.85,2.85,0,0,0,.46,1A2.9,2.9,0,0,0,219.11,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M206.94,106.85a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.21,3.87,4.17,4,2.35.13,3.56.52,3.41,2.43a8.39,8.39,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73a5.72,5.72,0,0,0,.28.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.87-6.67-.22-4.86-7.52-2.9-11.7S207.94,107.36,206.94,106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M199.28,116.9a2.9,2.9,0,0,0,1.46-2.85,2.87,2.87,0,0,0-3.17-2.53,3,3,0,0,0-.59.13,2.9,2.9,0,0,0-1.83,3.66,3.06,3.06,0,0,0,.22.49,2.87,2.87,0,0,0,3.91,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M180.81,103a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.71-5.7-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C183.33,103.16,182.4,104,180.81,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M181.51,94.28a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M190.7,103.21c3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.93,2.41,1.14,3.46,1.14,3.46,3-.85,2.8-2.93,1.52-5.61-1-2.13-1.26-3.38.49-4.17a8.09,8.09,0,0,1,1.8-.53c2.77-.54,5.41-1.62,7-3.33a3.66,3.66,0,0,0,.46-.58,5.26,5.26,0,0,0,.64-1.16C195.27,106.14,191,103.36,190.7,103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M186.75,122.11a2.85,2.85,0,0,0,1.61.43,2.8,2.8,0,0,0,1.58-.53,2.89,2.89,0,0,0,1-1.31,2.8,2.8,0,0,0,.12-1.67,2.85,2.85,0,0,0-.82-1.45,2.9,2.9,0,0,0-4.83,1.58,2.74,2.74,0,0,0,0,1.14,3,3,0,0,0,.46,1A2.73,2.73,0,0,0,186.75,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M174.58,106.85a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.17,4,2.35.13,3.56.52,3.41,2.43a8.39,8.39,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73a4.48,4.48,0,0,0,.29.68,5.75,5.75,0,0,0,.7,1.13c2.91,3.5,7.39,1,7.67.87-6.68-.22-4.87-7.52-2.91-11.7S175.59,107.36,174.58,106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M166.92,116.9a3,3,0,0,0,1.17-1.2,2.88,2.88,0,0,0-1.78-4.09,2.83,2.83,0,0,0-1.68,0,2.92,2.92,0,0,0-1.37,1,2.89,2.89,0,0,0,2.6,4.65A3.1,3.1,0,0,0,166.92,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M148.46,103a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,17.69,17.69,0,0,0,1.55-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C151,103.16,150,104,148.46,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M149.15,94.28a2.89,2.89,0,0,0-2.91,2.87,3.31,3.31,0,0,0,0,.55,2.85,2.85,0,0,0,2.26,2.28,2.9,2.9,0,0,0,3-1.22,2.85,2.85,0,0,0,.49-1.6,2.92,2.92,0,0,0-.83-2A2.86,2.86,0,0,0,149.15,94.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M158.34,103.21c3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.13,3.46,1.13,3.46,3-.85,2.8-2.93,1.52-5.61-1-2.13-1.25-3.38.49-4.17a8.65,8.65,0,0,1,1.8-.53,13,13,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,4.88,4.88,0,0,0,.64-1.16C162.92,106.14,158.62,103.36,158.34,103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M154.4,122.11a2.73,2.73,0,0,0,1,.4,2.86,2.86,0,0,0,2.14-.49,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,2.9,2.9,0,0,0-.82-.78,2.73,2.73,0,0,0-1-.4,2.61,2.61,0,0,0-2.13.46,2.87,2.87,0,0,0-.77.82,3,3,0,0,0-.41,1.06,2.69,2.69,0,0,0,0,1.13,2.85,2.85,0,0,0,.46,1A2.89,2.89,0,0,0,154.4,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M142.23,106.85a10.29,10.29,0,0,0-4.06-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.18,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,5.25,5.25,0,0,0,.71,1.13c2.9,3.5,7.38,1,7.66.87-6.68-.22-4.87-7.52-2.91-11.7S143.23,107.36,142.23,106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M134.56,116.9a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0-.89,1.41,2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,.95,1.37,2.86,2.86,0,0,0,1.55.6A2.74,2.74,0,0,0,134.56,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M116.1,103a8.88,8.88,0,0,1-1.41-1.26C112.17,99,109,97,106.13,97.54c-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C118.61,103.16,117.68,104,116.1,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M116.79,94.28a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,0,0,3.76,3.77,2.9,2.9,0,0,0,1.78-2.66,2.77,2.77,0,0,0-.22-1.1,2.83,2.83,0,0,0-1.55-1.56A2.77,2.77,0,0,0,116.79,94.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M118.54,120.16c-1-2.13-1.25-3.38.49-4.17a8.17,8.17,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,4.88,4.88,0,0,0,.64-1.16c1.67-4.25-2.63-7-2.91-7.18,3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.52,3.92a10.62,10.62,0,0,0,1.28,3.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M126,121.2a2.91,2.91,0,0,0,.38-2.19,3,3,0,0,0-.46-1,3.24,3.24,0,0,0-.83-.78,2.87,2.87,0,0,0-1.06-.42,2.69,2.69,0,0,0-1.13,0,2.85,2.85,0,0,0-1,.46,2.94,2.94,0,0,0-.77.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M114,124.41c-6.68-.22-4.87-7.52-2.91-11.7s-.25-5.36-1.25-5.86a10.29,10.29,0,0,0-4.06-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.17,5.54-.43,7.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M102.2,116.9a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0-.89,1.41,2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,1,1.37,2.86,2.86,0,0,0,1.55.6A2.75,2.75,0,0,0,102.2,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M83.74,103a8.88,8.88,0,0,1-1.41-1.26C79.81,99,76.64,97,73.77,97.54c-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C86.26,103.16,85.32,104,83.74,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M84.44,94.28A2.88,2.88,0,0,0,81.77,96a2.82,2.82,0,0,0-.18,1.67A2.9,2.9,0,0,0,83.85,100a2.81,2.81,0,0,0,1.67-.16,2.9,2.9,0,0,0,1.78-2.66,2.86,2.86,0,0,0-2.84-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M86.67,116a8.17,8.17,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,5.74,5.74,0,0,0,.65-1.16c1.66-4.25-2.64-7-2.92-7.18,3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M81.67,124.41c-6.68-.22-4.86-7.52-2.91-11.7s-.25-5.36-1.25-5.86a10.29,10.29,0,0,0-4.06-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.17,5.54-.43,7.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M69.84,116.9a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.81,2.81,0,0,0-1.36,1.73,2.88,2.88,0,0,0,3.1,3.64A3.08,3.08,0,0,0,69.84,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M51.38,103A8.68,8.68,0,0,1,50,101.71C47.48,99,44.31,97,41.44,97.54c-4.46.84-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.81,2.32-2.81-2.31-2.09-3.95-.82-5.54,1.69C53.9,103.16,53,104,51.38,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M52.08,94.28A2.88,2.88,0,0,0,49.41,96a2.82,2.82,0,0,0-.18,1.67A2.9,2.9,0,0,0,51.49,100a2.88,2.88,0,1,0,.65-5.7h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M53.82,120.16c-1-2.13-1.25-3.38.49-4.17a8.17,8.17,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,5.74,5.74,0,0,0,.65-1.16c1.66-4.25-2.64-7-2.91-7.18,3,6-4.24,7.89-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M49.31,124.41c-6.68-.22-4.86-7.52-2.91-11.7s-.25-5.36-1.25-5.86a10.36,10.36,0,0,0-4-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.4,2.43a8.37,8.37,0,0,1-.4,1.85c-.85,2.7-1.17,5.54-.43,7.73a6.68,6.68,0,0,0,1,1.81c2.91,3.5,7.39,1,7.67.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M37.48,116.9a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.88,2.88,0,0,0,1.74,5.37A3.08,3.08,0,0,0,37.48,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M19,103a8.81,8.81,0,0,1-1.4-1.26C15.07,99,11.9,97,9,97.54c-4.46.84-4.52,6-4.52,6.29,3.46-5.74,8.91-.58,11.59,3.18s4.77,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17A18.43,18.43,0,0,0,26,102.29c1-2.92,2.32-2.81,2.32-2.81-2.32-2.09-4-.82-5.55,1.69C21.54,103.16,20.61,104,19,103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M19.72,94.28a2.89,2.89,0,0,0-1.61.48A3,3,0,0,0,17,96,2.88,2.88,0,0,0,19.09,100a2.81,2.81,0,0,0,1.67-.16,2.88,2.88,0,0,0-1.08-5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M28.91,103.21c3,6-4.24,7.89-8.82,8.17s-4.57,2.8-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.14,3.46,1.14,3.46,3-.85,2.79-2.93,1.51-5.61-1-2.13-1.25-3.38.49-4.17a8.74,8.74,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,3.6,3.6,0,0,0,.45-.58,5.74,5.74,0,0,0,.65-1.16C33.48,106.14,29.18,103.36,28.91,103.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M25,122.11a2.86,2.86,0,0,0,1.05.4,3,3,0,0,0,1.11,0A2.78,2.78,0,0,0,29,121.2a2.91,2.91,0,0,0,.38-2.19,3,3,0,0,0-.46-1,2.93,2.93,0,0,0-3-1.14,2.85,2.85,0,0,0-1,.46,3,3,0,0,0-.76.82,2.91,2.91,0,0,0-.38,2.19A3.29,3.29,0,0,0,25,122.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M12.79,106.85a10.36,10.36,0,0,0-4-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43A9,9,0,0,1,8.75,114c-.85,2.7-1.17,5.54-.43,7.73a6.68,6.68,0,0,0,1,1.81c2.91,3.5,7.39,1,7.67.87-6.68-.22-4.86-7.52-2.9-11.7S13.79,107.36,12.79,106.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M5.12,116.9a2.81,2.81,0,0,0,1.36-1.73A2.88,2.88,0,0,0,6.22,113a2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A3.08,3.08,0,0,0,5.12,116.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M375,70.46a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17A18.7,18.7,0,0,0,382,69.75c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-3.95-.83-5.54,1.69C377.48,70.65,376.55,71.52,375,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M375.66,61.77A2.89,2.89,0,0,0,373,63.54a2.88,2.88,0,1,0,5.54,1.14,2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M384.85,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.92a10.62,10.62,0,0,0,1.28,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.13,3.45,1.13,3.45,3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17a8.17,8.17,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,4.75,4.75,0,0,0,.64-1.17C389.43,73.63,385.13,70.86,384.85,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M380.91,89.6a2.91,2.91,0,0,0,1.6.42,2.87,2.87,0,0,0,1.57-.53,3,3,0,0,0,1-1.32,2.87,2.87,0,0,0-.71-3.09,2.87,2.87,0,0,0-1.48-.75A2.83,2.83,0,0,0,380,85.6a2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.7,2.7,0,0,0,380.91,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M368.74,74.36a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.69,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.43a8.88,8.88,0,0,1-.4,1.84c-.86,2.71-1.17,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69,4.71,4.71,0,0,0,.71,1.12c2.9,3.5,7.38,1,7.66.88-6.68-.22-4.87-7.52-2.91-11.7S369.74,74.84,368.74,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M361.07,84.36a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0-.89,1.41,2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,.95,1.37,2.86,2.86,0,0,0,1.55.6A2.74,2.74,0,0,0,361.07,84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M342.61,70.46a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.7,18.7,0,0,0,1.54-3.34c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-3.95-.83-5.54,1.69C345.13,70.65,344.19,71.52,342.61,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M343.31,61.77a2.89,2.89,0,0,0-2.85,3.43,2.93,2.93,0,0,0,.79,1.48,2.89,2.89,0,1,0,2.12-4.91h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M352.49,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.13,3.45,1.13,3.45,3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17a8.17,8.17,0,0,1,1.81-.53c2.77-.54,5.4-1.62,6.95-3.33a3.66,3.66,0,0,0,.46-.58,4.79,4.79,0,0,0,.65-1.17C357.07,73.63,352.77,70.86,352.49,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M348.55,89.6a2.91,2.91,0,0,0,1.6.42,2.87,2.87,0,0,0,1.57-.53,2.92,2.92,0,0,0,1-1.32,2.87,2.87,0,0,0-.71-3.09,2.87,2.87,0,0,0-1.48-.75,2.83,2.83,0,0,0-2.91,1.27,2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.92,2.92,0,0,0,348.55,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M336.38,74.36a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.68,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.43a8.88,8.88,0,0,1-.4,1.84c-.86,2.71-1.17,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69,4.71,4.71,0,0,0,.71,1.12c2.91,3.5,7.38,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.7S337.38,74.84,336.38,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M328.71,84.36a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0,.11,4.41,2.88,2.88,0,0,0,3.17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M310.25,70.46a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.7,18.7,0,0,0,1.54-3.34c1-2.92,2.32-2.8,2.32-2.8-2.31-2.09-3.95-.83-5.54,1.69C312.77,70.65,311.83,71.52,310.25,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M311,61.77a2.89,2.89,0,0,0-2.85,3.43,2.93,2.93,0,0,0,.79,1.48,2.9,2.9,0,0,0,5-2,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M320.14,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.14,3.45,1.14,3.45,3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17A8.17,8.17,0,0,1,315,83a13.1,13.1,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,5.82,5.82,0,0,0,.65-1.17C324.71,73.63,320.41,70.86,320.14,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M316.19,89.6a2.91,2.91,0,0,0,1.6.42,2.87,2.87,0,0,0,1.57-.53,3,3,0,0,0,1-1.32,2.82,2.82,0,0,0,.11-1.65,2.88,2.88,0,0,0-2.3-2.19,2.91,2.91,0,0,0-1.65.19,2.82,2.82,0,0,0-1.26,1.08,2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.8,2.8,0,0,0,316.19,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M304,74.36a10.36,10.36,0,0,0-4-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.4,2.43a7.65,7.65,0,0,1-.4,1.84c-.85,2.71-1.17,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.7S305,74.84,304,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M296.35,84.36a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.81,2.81,0,0,0,.72.85,3.16,3.16,0,0,0,1,.51,3,3,0,0,0,1.12.09A3.08,3.08,0,0,0,296.35,84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M277.89,70.46a8.81,8.81,0,0,1-1.4-1.26c-2.53-2.71-5.7-4.75-8.56-4.17-4.46.84-4.52,6-4.52,6.29,3.46-5.75,8.91-.59,11.59,3.18s4.77,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,18.7,18.7,0,0,0,1.54-3.34c1-2.92,2.32-2.8,2.32-2.8-2.32-2.09-4-.83-5.55,1.69C280.41,70.65,279.48,71.52,277.89,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M278.59,61.77a2.89,2.89,0,0,0-2.85,3.43A2.9,2.9,0,0,0,278,67.47a2.89,2.89,0,0,0,3.49-2.82,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M287.78,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.14,3.45,1.14,3.45,3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17a8.74,8.74,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,3.6,3.6,0,0,0,.45-.58,4.79,4.79,0,0,0,.65-1.17C292.35,73.63,288.05,70.86,287.78,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M283.83,89.6a2.91,2.91,0,0,0,1.6.42,2.87,2.87,0,0,0,1.57-.53,2.92,2.92,0,0,0,1-1.32,2.87,2.87,0,0,0-.71-3.09,2.87,2.87,0,0,0-1.48-.75,2.83,2.83,0,0,0-2.91,1.27,2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.7,2.7,0,0,0,283.83,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M271.66,74.36a10.21,10.21,0,0,0-4.05-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.41,2.43a8.9,8.9,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.9-11.7S272.66,74.84,271.66,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M264,84.36a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,2.64,2.64,0,0,0-1.12-.09,2.71,2.71,0,0,0-1.06.35,2.88,2.88,0,0,0,2.8,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M245.53,70.46a8.81,8.81,0,0,1-1.4-1.26c-2.53-2.71-5.7-4.75-8.56-4.17-4.46.84-4.52,6-4.51,6.29,3.45-5.75,8.91-.59,11.58,3.18s4.77,2.4,5.7,1.76A10.37,10.37,0,0,0,251,73.09a19.47,19.47,0,0,0,1.55-3.34c1-2.92,2.31-2.8,2.31-2.8-2.32-2.09-4-.83-5.54,1.69C248.05,70.65,247.12,71.52,245.53,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M246.23,61.77a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M255.42,70.69c3,6-4.23,7.9-8.82,8.18s-4.56,2.79-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,19,19,0,0,0,2,3.09c1.93,2.41,1.14,3.45,1.14,3.45,3-.86,2.79-2.93,1.52-5.61-1-2.13-1.26-3.39.48-4.17A8.74,8.74,0,0,1,250.3,83a13.09,13.09,0,0,0,7-3.33,6.51,6.51,0,0,0,.46-.58,5.78,5.78,0,0,0,.64-1.17C260,73.63,255.69,70.86,255.42,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M251.47,89.6a2.85,2.85,0,0,0,1.61.43,2.88,2.88,0,0,0,2.23-4.57,2.18,2.18,0,0,0-.34-.4,2.9,2.9,0,0,0-1.49-.75,3,3,0,0,0-1.65.2,2.92,2.92,0,0,0-1.27,1.09,2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.85,2.85,0,0,0,251.47,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M239.3,74.36a10.21,10.21,0,0,0-4.05-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.41,2.43a8.9,8.9,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.42,7.73a3.44,3.44,0,0,0,.28.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.67-.22-4.86-7.52-2.9-11.7S240.3,74.84,239.3,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M231.63,84.36a2.91,2.91,0,0,0,1.16-1.2,2.83,2.83,0,0,0,.29-1.64A2.89,2.89,0,0,0,231,79.09a3,3,0,0,0-1.67,0,2.89,2.89,0,0,0-1.36,1,2.74,2.74,0,0,0-.61,1.55,2.86,2.86,0,0,0,4.26,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M213.17,70.46a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.71-5.7-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,19.47,19.47,0,0,0,1.55-3.34c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.83-5.54,1.69C215.69,70.65,214.76,71.52,213.17,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M213.87,61.77a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M223.06,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.92A10.6,10.6,0,0,0,211,86.73a18.33,18.33,0,0,0,2,3.09c1.93,2.41,1.14,3.45,1.14,3.45,3-.86,2.8-2.93,1.52-5.61-1-2.13-1.26-3.39.49-4.17a8.09,8.09,0,0,1,1.8-.53c2.77-.54,5.41-1.62,7-3.33a3.66,3.66,0,0,0,.46-.58,5.11,5.11,0,0,0,.64-1.17C227.63,73.63,223.33,70.86,223.06,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M219.11,89.6a2.88,2.88,0,0,0,4.4-2.52,2.68,2.68,0,0,0-.07-.56,2.85,2.85,0,0,0-.82-1.45,2.9,2.9,0,0,0-1.49-.75,2.83,2.83,0,0,0-1.65.2,2.92,2.92,0,0,0-1.69,2.13,3.12,3.12,0,0,0,0,1.14,2.91,2.91,0,0,0,1.29,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M206.94,74.36a10.21,10.21,0,0,0-4.05-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.69,3,1.21,3.87,4.17,4,2.35.12,3.56.51,3.41,2.43a7.67,7.67,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.42,7.73a4.15,4.15,0,0,0,.28.69,5.44,5.44,0,0,0,.71,1.12c2.91,3.5,7.39,1,7.67.88-6.67-.22-4.86-7.52-2.9-11.7S207.94,74.84,206.94,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M199.28,84.36a2.9,2.9,0,0,0,1.46-2.85A2.87,2.87,0,0,0,197.57,79a3,3,0,0,0-.59.13,2.9,2.9,0,0,0-1.83,3.66,3.06,3.06,0,0,0,.22.49,2.87,2.87,0,0,0,3.91,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M180.81,70.46a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.71-5.7-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,18.75,18.75,0,0,0,1.55-3.34c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.83-5.54,1.69C183.33,70.65,182.4,71.52,180.81,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M181.51,61.77a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,1,0,5.54,1.14,2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M190.7,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.93,2.41,1.14,3.45,1.14,3.45,3-.86,2.8-2.93,1.52-5.61-1-2.13-1.26-3.39.49-4.17a8.09,8.09,0,0,1,1.8-.53c2.77-.54,5.41-1.62,7-3.33a3.66,3.66,0,0,0,.46-.58,5.11,5.11,0,0,0,.64-1.17C195.27,73.63,191,70.86,190.7,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M186.75,89.6a2.88,2.88,0,0,0,3-4.93,2.92,2.92,0,0,0-1-.37,2.69,2.69,0,0,0-1.13,0,2.85,2.85,0,0,0-1,.46,2.93,2.93,0,0,0-1.12,3A2.84,2.84,0,0,0,186.75,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M174.58,74.36a10.21,10.21,0,0,0-4.05-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.69,3,1.22,3.87,4.17,4,2.35.12,3.56.51,3.41,2.43a7.67,7.67,0,0,1-.41,1.84c-.85,2.71-1.17,5.55-.42,7.73a4.19,4.19,0,0,0,.29.69,5,5,0,0,0,.7,1.12c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.87-7.52-2.91-11.7S175.59,74.84,174.58,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M166.92,84.36a3,3,0,0,0,1.17-1.2,2.88,2.88,0,0,0-1.78-4.09,2.83,2.83,0,0,0-1.68,0,2.92,2.92,0,0,0-1.37,1,2.86,2.86,0,0,0-.24,3.2,2.81,2.81,0,0,0,.72.85,3.16,3.16,0,0,0,1,.51,3,3,0,0,0,1.12.09A3.1,3.1,0,0,0,166.92,84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M148.46,70.46a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17,18.07,18.07,0,0,0,1.55-3.34c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.83-5.54,1.69C151,70.65,150,71.52,148.46,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M149.15,61.77a2.89,2.89,0,0,0-2.67,1.77A2.88,2.88,0,1,0,152,64.68a2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M158.34,70.69c3,6-4.24,7.9-8.83,8.18S145,81.66,145,82.79a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.13,3.45,1.13,3.45,3-.86,2.8-2.93,1.52-5.61-1-2.13-1.25-3.39.49-4.17a8.65,8.65,0,0,1,1.8-.53,13,13,0,0,0,7-3.33,4.34,4.34,0,0,0,.46-.58,4.75,4.75,0,0,0,.64-1.17C162.92,73.63,158.62,70.86,158.34,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M154.4,89.6A2.91,2.91,0,0,0,156,90a2.87,2.87,0,0,0,1.57-.53,2.92,2.92,0,0,0,1-1.32,2.87,2.87,0,0,0-.71-3.09,2.87,2.87,0,0,0-1.48-.75,2.83,2.83,0,0,0-2.91,1.27,2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.7,2.7,0,0,0,154.4,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M142.23,74.36a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.69,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.43a8.28,8.28,0,0,1-.4,1.84c-.86,2.71-1.18,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69,4.71,4.71,0,0,0,.71,1.12c2.9,3.5,7.38,1,7.66.88-6.68-.22-4.87-7.52-2.91-11.7S143.23,74.84,142.23,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M134.56,84.36a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0-.89,1.41,2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,.95,1.37,2.86,2.86,0,0,0,1.55.6A2.74,2.74,0,0,0,134.56,84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M116.1,70.46a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.7,18.7,0,0,0,1.54-3.34c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.83-5.54,1.69C118.61,70.65,117.68,71.52,116.1,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M116.79,61.77a2.89,2.89,0,0,0-2.67,1.77,2.88,2.88,0,0,0,3.76,3.77,2.9,2.9,0,0,0,1.78-2.66,2.77,2.77,0,0,0-.22-1.1A2.83,2.83,0,0,0,117.89,62,2.77,2.77,0,0,0,116.79,61.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M126,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.92a10.62,10.62,0,0,0,1.28,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.13,3.45,1.13,3.45,3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17a8.17,8.17,0,0,1,1.81-.53,13.09,13.09,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,4.75,4.75,0,0,0,.64-1.17C130.56,73.63,126.26,70.86,126,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M122,89.6a2.91,2.91,0,0,0,1.6.42,2.87,2.87,0,0,0,1.57-.53,2.92,2.92,0,0,0,1-1.32A2.83,2.83,0,0,0,124,84.36a2.91,2.91,0,0,0-1.65.19,2.82,2.82,0,0,0-1.26,1.08,2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.87,2.87,0,0,0,122,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M109.87,74.36a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.69,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.43a8.88,8.88,0,0,1-.4,1.84c-.86,2.71-1.17,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69,4.71,4.71,0,0,0,.71,1.12c2.9,3.5,7.38,1,7.66.88-6.68-.22-4.87-7.52-2.91-11.7S110.87,74.84,109.87,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M102.2,84.36a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38A2.85,2.85,0,0,0,98,81.08a2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,1,1.37,2.86,2.86,0,0,0,1.55.6A2.75,2.75,0,0,0,102.2,84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M83.74,70.46a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.7,18.7,0,0,0,1.54-3.34c1-2.92,2.31-2.8,2.31-2.8-2.31-2.09-4-.83-5.54,1.69C86.26,70.65,85.32,71.52,83.74,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M84.44,61.77a2.89,2.89,0,0,0-2.85,3.43,2.9,2.9,0,0,0,2.26,2.27,2.81,2.81,0,0,0,1.67-.16,2.9,2.9,0,0,0,1.78-2.66,2.86,2.86,0,0,0-2.84-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M93.62,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.13,3.45,1.13,3.45,3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17A8.17,8.17,0,0,1,88.49,83a13.09,13.09,0,0,0,7-3.33,4.34,4.34,0,0,0,.46-.58,5.82,5.82,0,0,0,.65-1.17C98.2,73.63,93.9,70.86,93.62,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M89.68,89.6a2.91,2.91,0,0,0,1.6.42,2.87,2.87,0,0,0,1.57-.53,2.92,2.92,0,0,0,1-1.32,2.87,2.87,0,0,0-.71-3.09,2.87,2.87,0,0,0-1.48-.75,2.83,2.83,0,0,0-2.91,1.27,2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.7,2.7,0,0,0,89.68,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M77.51,74.36a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.56-.65-3.56-.65-.68,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.43a8.88,8.88,0,0,1-.4,1.84c-.86,2.71-1.17,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69A4.71,4.71,0,0,0,74,91c2.91,3.5,7.38,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.7S78.51,74.84,77.51,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M69.84,84.36a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0-.89,1.41,2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,1,1.37,2.86,2.86,0,0,0,1.55.6A2.75,2.75,0,0,0,69.84,84.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M51.38,70.46A8.68,8.68,0,0,1,50,69.2c-2.52-2.71-5.69-4.75-8.56-4.17-4.46.84-4.51,6-4.51,6.29,3.46-5.75,8.91-.59,11.58,3.18s4.78,2.4,5.7,1.76a10.54,10.54,0,0,0,2.66-3.17,18.7,18.7,0,0,0,1.54-3.34c1-2.92,2.32-2.8,2.32-2.8-2.31-2.09-3.95-.83-5.54,1.69C53.9,70.65,53,71.52,51.38,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M52.08,61.77a2.89,2.89,0,0,0-2.85,3.43,2.9,2.9,0,0,0,2.26,2.27,2.88,2.88,0,1,0,.65-5.7h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M61.27,70.69c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.92,2.41,1.14,3.45,1.14,3.45,3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17A8.17,8.17,0,0,1,56.15,83a13.09,13.09,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,5.82,5.82,0,0,0,.65-1.17C65.84,73.63,61.54,70.86,61.27,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M57.32,89.6a2.91,2.91,0,0,0,1.6.42,2.87,2.87,0,0,0,1.57-.53,2.92,2.92,0,0,0,1-1.32,2.87,2.87,0,0,0-.71-3.09,2.87,2.87,0,0,0-1.48-.75,2.83,2.83,0,0,0-2.91,1.27A2.66,2.66,0,0,0,56,86.66a3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.74,2.74,0,0,0,57.32,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M45.15,74.36a10.36,10.36,0,0,0-4-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.4,2.43a7.65,7.65,0,0,1-.4,1.84c-.85,2.71-1.17,5.55-.43,7.73a4.19,4.19,0,0,0,.29.69A5.44,5.44,0,0,0,41.68,91c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.7S46.15,74.84,45.15,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M37.48,84.36a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36A2.64,2.64,0,0,0,35.74,79a2.71,2.71,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.71,2.71,0,0,0,.73.85,2.79,2.79,0,0,0,1,.51,2.79,2.79,0,0,0,2.17-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M19,70.46a8.81,8.81,0,0,1-1.4-1.26C15.07,66.49,11.9,64.45,9,65c-4.46.84-4.52,6-4.52,6.29,3.46-5.75,8.91-.59,11.59,3.18s4.77,2.4,5.7,1.76a10.37,10.37,0,0,0,2.65-3.17A18.52,18.52,0,0,0,26,69.77c1-2.92,2.32-2.8,2.32-2.8-2.32-2.09-4-.83-5.55,1.69C21.54,70.65,20.61,71.52,19,70.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M19.72,61.77a3,3,0,0,0-1.61.47A3.09,3.09,0,0,0,17,63.53a2.88,2.88,0,0,0,2.09,3.94,2.82,2.82,0,0,0,3.27-3.87,2.89,2.89,0,0,0-2.64-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M28.91,70.69c3,6-4.24,7.9-8.82,8.18s-4.57,2.79-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09C20.76,92.23,20,93.27,20,93.27c3-.86,2.79-2.93,1.51-5.61-1-2.13-1.25-3.39.49-4.17A8.74,8.74,0,0,1,23.79,83a13.09,13.09,0,0,0,7-3.33,6.41,6.41,0,0,0,.45-.58,5.82,5.82,0,0,0,.65-1.17C33.48,73.63,29.18,70.86,28.91,70.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M25,89.6a2.91,2.91,0,0,0,1.6.42,2.87,2.87,0,0,0,1.57-.53,2.92,2.92,0,0,0,1-1.32,2.86,2.86,0,0,0-5.08-2.54,2.7,2.7,0,0,0-.41,1.06,3.07,3.07,0,0,0,0,1.13,3.28,3.28,0,0,0,.47,1A2.87,2.87,0,0,0,25,89.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M12.79,74.36a10.36,10.36,0,0,0-4-.77,18.59,18.59,0,0,0-3.65.27c-3,.54-3.57-.65-3.57-.65-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.41,2.43a8.9,8.9,0,0,1-.41,1.84C7.9,84.19,7.58,87,8.32,89.21a4.19,4.19,0,0,0,.29.69A5.44,5.44,0,0,0,9.32,91c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.9-11.7S13.79,74.84,12.79,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M5.12,84.36a2.81,2.81,0,0,0,1.36-1.73,2.88,2.88,0,0,0-.26-2.19A2.82,2.82,0,0,0,4.5,79.08,2.64,2.64,0,0,0,3.38,79a2.71,2.71,0,0,0-1.06.35,2.88,2.88,0,0,0,2.8,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M375,37.94a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18A18.52,18.52,0,0,0,382,37.26c1-2.92,2.31-2.8,2.31-2.8-2.31-2.1-3.95-.83-5.54,1.69C377.48,38.14,376.55,39,375,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M375.66,29.25A2.89,2.89,0,0,0,373,31a2.88,2.88,0,1,0,5.54,1.14,2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M384.85,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.91a10.61,10.61,0,0,0,1.28,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.17,8.17,0,0,1,1.81-.53,13.31,13.31,0,0,0,7-3.33,5.09,5.09,0,0,0,.46-.58,4.75,4.75,0,0,0,.64-1.17C389.43,41.12,385.13,38.36,384.85,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M380.91,57.09a3.09,3.09,0,0,0,1,.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,2.9,2.9,0,0,0-.82-.78,2.86,2.86,0,0,0-1-.4,2.91,2.91,0,0,0-2.14.5,3,3,0,0,0-.76.82,2.91,2.91,0,0,0-.38,2.19,3,3,0,0,0,.46,1A3.13,3.13,0,0,0,380.91,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M368.74,41.83a10.48,10.48,0,0,0-4.06-.78,18.17,18.17,0,0,0-3.68.31c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.42a9,9,0,0,1-.4,1.85c-.86,2.71-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.9,3.5,7.38,1,7.66.88-6.68-.22-4.87-7.52-2.91-11.71S369.74,42.36,368.74,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M361.07,51.88a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0-.89,1.41,2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,.95,1.37,2.86,2.86,0,0,0,1.55.6A2.74,2.74,0,0,0,361.07,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M342.61,37.94a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.1-3.95-.83-5.54,1.69C345.13,38.14,344.19,39,342.61,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M343.31,35a2.88,2.88,0,1,0-2.87-2.89h0A2.88,2.88,0,0,0,343.31,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M352.49,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.91a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.17,8.17,0,0,1,1.81-.53c2.77-.55,5.4-1.63,6.95-3.33a3.66,3.66,0,0,0,.46-.58,5.56,5.56,0,0,0,.65-1.17C357.07,41.12,352.77,38.36,352.49,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M348.55,57.09a3,3,0,0,0,1.05.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,3,3,0,0,0-.46-1,3.24,3.24,0,0,0-.83-.78,2.81,2.81,0,0,0-2.17-.36,2.85,2.85,0,0,0-1,.46,3,3,0,0,0-.76.82,2.91,2.91,0,0,0-.38,2.19,2.87,2.87,0,0,0,.47,1A3,3,0,0,0,348.55,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M336.38,41.83a10.48,10.48,0,0,0-4.06-.78,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.68,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.42a9,9,0,0,1-.4,1.85c-.86,2.71-1.17,5.55-.43,7.73a4.48,4.48,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.91,3.5,7.38,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.71S337.38,42.36,336.38,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M328.71,51.88a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0,.11,4.41,2.88,2.88,0,0,0,3.17.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M310.25,37.94a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.8,2.32-2.8-2.31-2.1-3.95-.83-5.54,1.69C312.77,38.14,311.83,39,310.25,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M311,35a2.88,2.88,0,1,0-2.87-2.89h0A2.86,2.86,0,0,0,311,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M320.14,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.91a10.42,10.42,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16A8.17,8.17,0,0,1,315,50.5a13.25,13.25,0,0,0,7-3.33,5.09,5.09,0,0,0,.46-.58,5.82,5.82,0,0,0,.65-1.17C324.71,41.12,320.41,38.36,320.14,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M316.19,57.09a3,3,0,0,0,1.05.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,3,3,0,0,0-1.88-1.2,3.07,3.07,0,0,0-1.13,0,2.87,2.87,0,0,0-1,.47,2.94,2.94,0,0,0-.77.84,2.8,2.8,0,0,0,.12,3.2A2.77,2.77,0,0,0,316.19,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M304,41.83a10.37,10.37,0,0,0-4-.78,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.4,2.42a7.84,7.84,0,0,1-.4,1.85c-.85,2.71-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.71S305,42.36,304,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M296.35,51.88a2.87,2.87,0,0,0,1.1-3.92,2.81,2.81,0,0,0-1.72-1.37,3,3,0,0,0-1.12-.09,3.08,3.08,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A2.87,2.87,0,0,0,296.35,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M277.89,37.94a8.36,8.36,0,0,1-1.4-1.26c-2.53-2.7-5.7-4.74-8.56-4.16-4.46.83-4.52,6-4.52,6.29,3.46-5.74,8.91-.58,11.59,3.18s4.77,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.8,2.32-2.8-2.32-2.1-4-.83-5.55,1.69C280.41,38.14,279.48,39,277.89,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M278.59,29.25a2.89,2.89,0,0,0-2.85,3.43A2.9,2.9,0,0,0,278,35a2.89,2.89,0,0,0,3.49-2.82,2.94,2.94,0,0,0-.83-2,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M287.78,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.91a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.74,8.74,0,0,1,1.81-.53,13.31,13.31,0,0,0,7-3.33,6.41,6.41,0,0,0,.45-.58,5.56,5.56,0,0,0,.65-1.17C292.35,41.12,288.05,38.36,287.78,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M283.83,57.09a2.85,2.85,0,0,0,1.61.43A2.88,2.88,0,0,0,287.67,53a2.18,2.18,0,0,0-.34-.4,2.9,2.9,0,0,0-1.49-.75,3,3,0,0,0-1.65.2,2.89,2.89,0,0,0-1.65,3.28,2.87,2.87,0,0,0,.47,1A3,3,0,0,0,283.83,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M271.66,41.83a10.39,10.39,0,0,0-4.05-.78,18.22,18.22,0,0,0-3.61.31c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.41,2.42a9,9,0,0,1-.41,1.85c-.85,2.71-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.9-11.71S272.66,42.36,271.66,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M264,51.88a2.88,2.88,0,0,0-1.73-5.38,2.82,2.82,0,0,0-.34,5.44,3,3,0,0,0,2.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M245.53,37.94a7.3,7.3,0,0,1-1.4-1.26c-2.53-2.7-5.7-4.74-8.56-4.16-4.46.83-4.52,6-4.51,6.29,3.45-5.74,8.91-.58,11.58,3.18s4.77,2.4,5.7,1.77A10.29,10.29,0,0,0,251,40.58a19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.32-2.1-4-.83-5.54,1.69C248.05,38.14,247.12,39,245.53,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M246.23,35a2.88,2.88,0,1,0-2.87-2.89h0A2.86,2.86,0,0,0,246.22,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M255.42,38.18c3,6-4.23,7.9-8.82,8.18s-4.56,2.79-4.52,3.91a10.53,10.53,0,0,0,1.27,4,18.89,18.89,0,0,0,2,3.08c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.52-5.62-1-2.12-1.26-3.38.48-4.16a8.74,8.74,0,0,1,1.81-.53,13.31,13.31,0,0,0,7-3.33,6.51,6.51,0,0,0,.46-.58,5.78,5.78,0,0,0,.64-1.17C260,41.12,255.69,38.36,255.42,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M251.47,57.09a3,3,0,0,0,1.05.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82,2.85,2.85,0,0,0,.43-1.61,2.8,2.8,0,0,0-.53-1.58,2.87,2.87,0,0,0-3-1.12,2.74,2.74,0,0,0-1.44.83,2.81,2.81,0,0,0-.74,1.49,3,3,0,0,0,.22,1.66A2.86,2.86,0,0,0,251.47,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M239.3,41.83a10.39,10.39,0,0,0-4.05-.78,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.41,2.42a9,9,0,0,1-.41,1.85c-.85,2.71-1.17,5.55-.42,7.73a3.36,3.36,0,0,0,.28.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.88-6.67-.22-4.86-7.52-2.9-11.71S240.3,42.36,239.3,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M231.63,51.88a2.87,2.87,0,0,0-.6-5.29,2.83,2.83,0,0,0-1.68,0,2.92,2.92,0,0,0-1.37,1,2.8,2.8,0,0,0-.61,1.56,2.88,2.88,0,0,0,4.26,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M213.17,37.94a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.7-5.7-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.1-4-.83-5.54,1.69C215.69,38.14,214.76,39,213.17,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M213.87,35A2.88,2.88,0,1,0,211,32.12h0A2.86,2.86,0,0,0,213.86,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M223.06,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.91a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.12-1.26-3.38.49-4.16a8.09,8.09,0,0,1,1.8-.53c2.77-.55,5.41-1.63,7-3.33a5.09,5.09,0,0,0,.46-.58,5.23,5.23,0,0,0,.61-1.23C227.63,41.12,223.33,38.36,223.06,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M219.11,57.09a3.09,3.09,0,0,0,1,.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82,3,3,0,0,0,.41-1.06,2.69,2.69,0,0,0,0-1.13,2.85,2.85,0,0,0-.46-1,2.9,2.9,0,0,0-.82-.78,2.81,2.81,0,0,0-2.17-.36,2.85,2.85,0,0,0-1,.46,3,3,0,0,0-.76.82,3.07,3.07,0,0,0-.41,1.05,3.12,3.12,0,0,0,0,1.14,2.85,2.85,0,0,0,.46,1A3,3,0,0,0,219.11,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-277",
    d: "M206.94,41.83a10.39,10.39,0,0,0-4.05-.78,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.21,3.87,4.17,4,2.35.12,3.56.51,3.41,2.42a7.85,7.85,0,0,1-.41,1.85c-.85,2.71-1.17,5.54-.42,7.73a4.43,4.43,0,0,0,.28.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.88-6.67-.22-4.86-7.52-2.9-11.71S207.94,42.36,206.94,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M199.28,51.88a2.89,2.89,0,0,0,.8-4.38,2.88,2.88,0,0,0-4.94,2.74,3.14,3.14,0,0,0,.23.53A2.89,2.89,0,0,0,199.28,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M180.81,37.94a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.7-5.7-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.1-4-.83-5.54,1.69C183.33,38.14,182.4,39,180.81,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M181.51,29.25A2.89,2.89,0,0,0,178.84,31a2.88,2.88,0,1,0,5.54,1.14,2.77,2.77,0,0,0-.22-1.1,3,3,0,0,0-2.65-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M190.7,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.91a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.12-1.26-3.38.49-4.16a8.09,8.09,0,0,1,1.8-.53c2.77-.55,5.41-1.63,7-3.33a6.15,6.15,0,0,0,1.1-1.75C195.27,41.12,191,38.36,190.7,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M186.75,57.09a2.85,2.85,0,0,0,1.61.43,2.8,2.8,0,0,0,1.58-.53,2.89,2.89,0,0,0,1-1.31,2.8,2.8,0,0,0,.12-1.67,2.85,2.85,0,0,0-.82-1.45,2.9,2.9,0,0,0-4.83,1.58,3.12,3.12,0,0,0,0,1.14,2.92,2.92,0,0,0,1.34,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M174.58,41.83a10.39,10.39,0,0,0-4.05-.78,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.17,4,2.35.12,3.56.51,3.41,2.42a7.85,7.85,0,0,1-.41,1.85c-.85,2.71-1.17,5.54-.42,7.73a4.48,4.48,0,0,0,.29.68,5.75,5.75,0,0,0,.7,1.13c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.87-7.52-2.91-11.71S175.59,42.36,174.58,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M166.92,51.88a2.88,2.88,0,1,0-3.65-4.31,2.8,2.8,0,0,0-.61,1.56,2.85,2.85,0,0,0,.36,1.64,2.81,2.81,0,0,0,.72.85,3.18,3.18,0,0,0,1,.52,2.77,2.77,0,0,0,1.11.08A2.86,2.86,0,0,0,166.92,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M148.46,37.94a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,17.69,17.69,0,0,0,1.55-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.1-4-.83-5.54,1.69C151,38.14,150,39,148.46,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M149.15,35a2.88,2.88,0,1,0-2.87-2.89h0A2.86,2.86,0,0,0,149.14,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M158.34,38.18c3,6-4.24,7.9-8.83,8.18S145,49.15,145,50.27a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.12-1.25-3.38.49-4.16a8.65,8.65,0,0,1,1.8-.53,13.16,13.16,0,0,0,7-3.33,4.34,4.34,0,0,0,.46-.58,4.75,4.75,0,0,0,.64-1.17C162.92,41.12,158.62,38.36,158.34,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-288",
    d: "M154.4,57.09a3.09,3.09,0,0,0,1,.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,2.47,2.47,0,0,0-2.9-1,2.89,2.89,0,0,0-.92,5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-289",
    d: "M142.23,41.83a10.48,10.48,0,0,0-4.06-.78,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.42a8.37,8.37,0,0,1-.4,1.85c-.86,2.71-1.18,5.55-.43,7.73a4.48,4.48,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.9,3.5,7.38,1,7.66.88-6.68-.22-4.87-7.52-2.91-11.71S143.23,42.36,142.23,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-290",
    d: "M134.56,51.88a2.88,2.88,0,1,0-3.65-4.31,2.8,2.8,0,0,0-.61,1.56,2.85,2.85,0,0,0,.36,1.64,2.81,2.81,0,0,0,.72.85,3.18,3.18,0,0,0,1,.52,2.77,2.77,0,0,0,1.11.08A2.86,2.86,0,0,0,134.56,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M116.1,37.94a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.1-4-.83-5.54,1.69C118.61,38.14,117.68,39,116.1,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-292",
    d: "M116.79,35a2.88,2.88,0,1,0-2.87-2.89h0A2.86,2.86,0,0,0,116.78,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M126,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.52,3.91a10.61,10.61,0,0,0,1.28,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.17,8.17,0,0,1,1.81-.53,13.31,13.31,0,0,0,7-3.33,5.09,5.09,0,0,0,.46-.58,4.74,4.74,0,0,0,.67-1.23C130.56,41.12,126.26,38.36,126,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-294",
    d: "M122,57.09a3.09,3.09,0,0,0,1,.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,3,3,0,0,0-1.88-1.2,3.07,3.07,0,0,0-1.13,0,2.87,2.87,0,0,0-1,.47,2.94,2.94,0,0,0-.77.84,2.8,2.8,0,0,0,.12,3.2A3.08,3.08,0,0,0,122,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-295",
    d: "M109.87,41.83a10.48,10.48,0,0,0-4.06-.78,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.42a9,9,0,0,1-.4,1.85c-.86,2.71-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.9,3.5,7.38,1,7.66.88-6.68-.22-4.87-7.52-2.91-11.71S110.87,42.36,109.87,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M102.2,51.88a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38A2.85,2.85,0,0,0,98,48.6a2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,1,1.37,2.86,2.86,0,0,0,1.55.6A2.75,2.75,0,0,0,102.2,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-297",
    d: "M83.74,37.94a8.47,8.47,0,0,1-1.41-1.26c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.8,2.31-2.8-2.31-2.1-4-.83-5.54,1.69C86.26,38.14,85.32,39,83.74,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M84.44,29.25a2.89,2.89,0,0,0-2.85,3.43A2.9,2.9,0,0,0,83.85,35a2.81,2.81,0,0,0,1.67-.16,2.9,2.9,0,0,0,1.78-2.66,2.86,2.86,0,0,0-2.84-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M93.62,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.91a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.17,8.17,0,0,1,1.81-.53,13.31,13.31,0,0,0,7-3.33,5.09,5.09,0,0,0,.46-.58,5.79,5.79,0,0,0,.65-1.23C98.2,41.12,93.9,38.36,93.62,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M89.68,57.09a3.09,3.09,0,0,0,1,.4,2.91,2.91,0,0,0,2.14-.5,3,3,0,0,0,.76-.82A2.91,2.91,0,0,0,94,54a2.87,2.87,0,0,0-.47-1,3,3,0,0,0-1.88-1.2,3.07,3.07,0,0,0-1.13,0,2.87,2.87,0,0,0-1,.47,2.94,2.94,0,0,0-.77.84,2.89,2.89,0,0,0-.36,2.2,3.11,3.11,0,0,0,1.33,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M77.51,41.83a10.48,10.48,0,0,0-4.06-.78,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.68,3,1.22,3.87,4.18,4,2.34.12,3.55.51,3.4,2.42a9,9,0,0,1-.4,1.85c-.86,2.71-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68A4.58,4.58,0,0,0,74,58.48c2.91,3.5,7.38,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.71S78.51,42.36,77.51,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M69.84,51.88a2.88,2.88,0,0,0-.1-5.07,2.88,2.88,0,0,0-3.17.38,2.85,2.85,0,0,0-.89,1.41,2.93,2.93,0,0,0,0,1.66,3,3,0,0,0,1,1.37,2.86,2.86,0,0,0,1.55.6A2.75,2.75,0,0,0,69.84,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-303",
    d: "M51.38,37.94A8.27,8.27,0,0,1,50,36.68c-2.52-2.7-5.69-4.74-8.56-4.16-4.46.83-4.51,6-4.51,6.29,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.8,2.32-2.8-2.31-2.1-3.95-.83-5.54,1.69C53.9,38.14,53,39,51.38,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M52.08,35a2.88,2.88,0,1,0-2.87-2.89h0A2.86,2.86,0,0,0,52.07,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-305",
    d: "M61.27,38.18c3,6-4.24,7.9-8.83,8.18s-4.56,2.79-4.51,3.91a10.53,10.53,0,0,0,1.27,4,18.25,18.25,0,0,0,2,3.08c1.92,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.17,8.17,0,0,1,1.81-.53,13.31,13.31,0,0,0,7-3.33,3.66,3.66,0,0,0,.46-.58,5.82,5.82,0,0,0,.65-1.17C65.84,41.12,61.54,38.36,61.27,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-306",
    d: "M57.32,57.09a3.09,3.09,0,0,0,2.19.41,2.87,2.87,0,0,0,1-.47,2.94,2.94,0,0,0,.77-.84A2.91,2.91,0,0,0,61.66,54a3,3,0,0,0-.46-1,3.24,3.24,0,0,0-.83-.78,2.87,2.87,0,0,0-1.06-.42,3.07,3.07,0,0,0-1.13,0,2.87,2.87,0,0,0-1,.47,2.94,2.94,0,0,0-.77.84A2.91,2.91,0,0,0,56,55.3a2.87,2.87,0,0,0,.47,1A3.08,3.08,0,0,0,57.32,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M45.15,41.83a10.37,10.37,0,0,0-4-.78,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.4,2.42a7.84,7.84,0,0,1-.4,1.85c-.85,2.71-1.17,5.54-.43,7.73a4.32,4.32,0,0,0,.32.69,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.91-11.71S46.15,42.36,45.15,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M37.48,51.88a2.88,2.88,0,0,0-1.73-5.38,2.7,2.7,0,0,0-1.07.35,2.87,2.87,0,0,0-1.1,3.92,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A2.87,2.87,0,0,0,37.48,51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-309",
    d: "M19,37.94a7.3,7.3,0,0,1-1.4-1.26C15.07,34,11.9,31.94,9,32.52c-4.46.83-4.52,6-4.52,6.29C8,33.07,13.43,38.23,16.11,42s4.77,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18A18.52,18.52,0,0,0,26,37.26c1-2.92,2.32-2.8,2.32-2.8-2.32-2.1-4-.83-5.55,1.69C21.54,38.14,20.61,39,19,37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M19.72,35a2.88,2.88,0,1,0-2.87-2.89h0A2.86,2.86,0,0,0,19.71,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-311",
    d: "M28.91,38.18c3,6-4.24,7.9-8.82,8.18s-4.57,2.79-4.52,3.91a10.53,10.53,0,0,0,1.27,4,19.58,19.58,0,0,0,2,3.08C20.76,59.76,20,60.81,20,60.81c3-.86,2.79-2.93,1.51-5.62-1-2.12-1.25-3.38.49-4.16a8.74,8.74,0,0,1,1.81-.53,13.31,13.31,0,0,0,7-3.33,6.41,6.41,0,0,0,.45-.58,5.82,5.82,0,0,0,.65-1.17C33.48,41.12,29.18,38.36,28.91,38.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-312",
    d: "M25,57.09a2.85,2.85,0,0,0,1.61.43A2.88,2.88,0,0,0,28.84,53a2.18,2.18,0,0,0-.34-.4A2.9,2.9,0,0,0,27,51.8a3,3,0,0,0-1.65.2,2.89,2.89,0,0,0-1.65,3.28,2.87,2.87,0,0,0,.47,1A3,3,0,0,0,25,57.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-313",
    d: "M12.79,41.83a10.37,10.37,0,0,0-4-.78,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.12,3.56.51,3.41,2.42a9,9,0,0,1-.41,1.85c-.85,2.71-1.17,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.88-6.68-.22-4.86-7.52-2.9-11.71S13.79,42.36,12.79,41.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M5.12,51.88A2.87,2.87,0,0,0,6.22,48a3,3,0,0,0-.72-.86,2.88,2.88,0,0,0-2.11-.6,2.7,2.7,0,0,0-1.07.35,2.89,2.89,0,0,0,.73,5.09,3,3,0,0,0,2.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-315",
    d: "M375,5.43a8.88,8.88,0,0,1-1.41-1.26C371.07,1.46,367.9-.57,365,0c-4.46.84-4.51,6-4.51,6.3,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.46,10.46,0,0,0,2.66-3.18A18.61,18.61,0,0,0,382,4.74c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-3.95-.82-5.54,1.69C377.48,5.63,376.55,6.5,375,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-316",
    d: "M375.66-3.26a2.94,2.94,0,0,0-1.6.48A2.85,2.85,0,0,0,373-1.49a2.86,2.86,0,0,0,.62,3.14,2.88,2.88,0,0,0,4.07,0,2.87,2.87,0,0,0,.85-2,2.77,2.77,0,0,0-.22-1.1A2.83,2.83,0,0,0,376.77-3,2.85,2.85,0,0,0,375.66-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-317",
    d: "M384.85,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.52,3.92a10.62,10.62,0,0,0,1.28,3.94,17.94,17.94,0,0,0,2,3.09c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.13-1.25-3.38.49-4.17a8.15,8.15,0,0,1,1.81-.52,13.21,13.21,0,0,0,7-3.34,3.66,3.66,0,0,0,.46-.58,4.88,4.88,0,0,0,.64-1.16C389.43,8.61,385.13,5.84,384.85,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-318",
    d: "M380.91,24.57a2.73,2.73,0,0,0,1,.4,2.86,2.86,0,0,0,2.14-.49,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,2.9,2.9,0,0,0-.82-.78,2.86,2.86,0,0,0-1-.4,3,3,0,0,0-1.11,0A2.85,2.85,0,0,0,380,20.57a2.91,2.91,0,0,0-.38,2.19,3,3,0,0,0,.46,1A3.24,3.24,0,0,0,380.91,24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M368.74,9.36a10.29,10.29,0,0,0-4.06-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.17,5.54-.43,7.73a5.79,5.79,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.9,3.5,7.38,1,7.66.87-6.68-.23-4.87-7.53-2.91-11.71S369.74,9.81,368.74,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M361.07,19.36a2.87,2.87,0,1,0-3.65-4.24,2.74,2.74,0,0,0-.61,1.55,2.88,2.88,0,0,0,3.2,3.08A2.82,2.82,0,0,0,361.07,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M342.61,5.43a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.3,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-3.95-.82-5.54,1.69C345.13,5.63,344.19,6.5,342.61,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-322",
    d: "M343.31-3.26a2.88,2.88,0,0,0-2.67,1.76,2.82,2.82,0,0,0-.18,1.67,2.93,2.93,0,0,0,.79,1.48,2.87,2.87,0,0,0,1.47.79,2.86,2.86,0,0,0,3-1.22,2.85,2.85,0,0,0,.49-1.6,3,3,0,0,0-.21-1.1,3.09,3.09,0,0,0-.62-.93,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-323",
    d: "M352.49,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,17.94,17.94,0,0,0,2,3.09c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.13-1.25-3.38.49-4.17a8.15,8.15,0,0,1,1.81-.52c2.77-.55,5.4-1.63,6.95-3.34a3.66,3.66,0,0,0,.46-.58,5.74,5.74,0,0,0,.65-1.16C357.07,8.61,352.77,5.84,352.49,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-324",
    d: "M348.55,24.57a2.86,2.86,0,0,0,1.05.4,3,3,0,0,0,1.11,0,2.79,2.79,0,0,0,1.79-1.28,2.91,2.91,0,0,0,.38-2.19,3,3,0,0,0-.46-1,3.24,3.24,0,0,0-.83-.78,2.73,2.73,0,0,0-1-.4,3,3,0,0,0-1.12,0,2.85,2.85,0,0,0-1.79,1.28,2.91,2.91,0,0,0-.38,2.19,3.21,3.21,0,0,0,1.25,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M336.38,9.36a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.17,5.54-.43,7.73a5.79,5.79,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.91,3.5,7.38,1,7.67.87-6.68-.23-4.86-7.53-2.91-11.71S337.38,9.81,336.38,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M328.71,19.36a2.91,2.91,0,0,0,1.16-1.2,2.83,2.83,0,0,0,.29-1.64,2.8,2.8,0,0,0-.67-1.53,2.84,2.84,0,0,0-1.4-.9,3,3,0,0,0-1.67,0,2.89,2.89,0,0,0-1.36,1,2.74,2.74,0,0,0-.61,1.55,2.84,2.84,0,0,0,4.26,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M310.25,5.43a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.3,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.81,2.32-2.81-2.31-2.09-3.95-.82-5.54,1.69C312.77,5.63,311.83,6.5,310.25,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M311-3.26a2.88,2.88,0,0,0-2.67,1.76,2.82,2.82,0,0,0-.18,1.67,2.93,2.93,0,0,0,.79,1.48,2.87,2.87,0,0,0,1.47.79,2.86,2.86,0,0,0,3-1.22,2.85,2.85,0,0,0,.49-1.6,2.77,2.77,0,0,0-.22-1.1,2.89,2.89,0,0,0-.61-.93,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M320.14,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,17.94,17.94,0,0,0,2,3.09c1.92,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.13-1.25-3.38.49-4.17a8.15,8.15,0,0,1,1.81-.52,13.19,13.19,0,0,0,7-3.34,3.66,3.66,0,0,0,.46-.58,5.74,5.74,0,0,0,.65-1.16C324.71,8.61,320.41,5.84,320.14,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M316.19,24.57a2.73,2.73,0,0,0,1,.4,2.61,2.61,0,0,0,2.13-.46,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,3,3,0,0,0-1.88-1.2,3.07,3.07,0,0,0-1.13,0,2.87,2.87,0,0,0-1,.47,2.78,2.78,0,0,0-.77.83,2.8,2.8,0,0,0,.12,3.2A3,3,0,0,0,316.19,24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M304,9.36a10.36,10.36,0,0,0-4-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.4,2.43a7.84,7.84,0,0,1-.4,1.85c-.85,2.7-1.17,5.54-.43,7.73a6.68,6.68,0,0,0,1,1.81c2.91,3.5,7.39,1,7.67.87-6.68-.23-4.86-7.53-2.91-11.71S305,9.81,304,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M296.35,19.36a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36,3,3,0,0,0-1.12-.09,3.08,3.08,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A3.08,3.08,0,0,0,296.35,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M277.89,5.43a8.81,8.81,0,0,1-1.4-1.26C274,1.46,270.79-.57,267.93,0c-4.46.84-4.52,6-4.52,6.3,3.46-5.74,8.91-.58,11.59,3.18s4.77,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.81,2.32-2.81-2.32-2.09-4-.82-5.55,1.69C280.41,5.63,279.48,6.5,277.89,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M278.59-3.26a2.88,2.88,0,0,0-2.67,1.76,2.82,2.82,0,0,0-.18,1.67A2.9,2.9,0,0,0,278,2.44a2.86,2.86,0,0,0,3-1.22,2.85,2.85,0,0,0,.49-1.6,2.77,2.77,0,0,0-.22-1.1,2.89,2.89,0,0,0-.61-.93,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M287.78,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,17.94,17.94,0,0,0,2,3.09c1.92,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.13-1.25-3.38.49-4.17a8.72,8.72,0,0,1,1.81-.52,13.21,13.21,0,0,0,7-3.34,5.09,5.09,0,0,0,.46-.58,5.7,5.7,0,0,0,.64-1.16C292.35,8.61,288.05,5.84,287.78,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M283.83,24.57a2.86,2.86,0,0,0,1.05.4A3,3,0,0,0,286,25a2.79,2.79,0,0,0,1.79-1.28,2.94,2.94,0,0,0,.44-1.61,2.86,2.86,0,0,0-2.94-2.79,2.79,2.79,0,0,0-.58.07,2.92,2.92,0,0,0-1.44.83,2.88,2.88,0,0,0-.53,3.14A2.93,2.93,0,0,0,283.83,24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M271.66,9.36a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a9,9,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.43,7.73a6.68,6.68,0,0,0,1,1.81c2.91,3.5,7.39,1,7.67.87-6.68-.23-4.86-7.53-2.9-11.71S272.66,9.81,271.66,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M264,19.36a2.87,2.87,0,1,0-3.65-4.24,2.74,2.74,0,0,0-.61,1.55A2.84,2.84,0,0,0,264,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-339",
    d: "M245.53,5.43a8.81,8.81,0,0,1-1.4-1.26c-2.53-2.71-5.7-4.74-8.56-4.17-4.46.84-4.52,6-4.51,6.3,3.45-5.74,8.91-.58,11.58,3.18s4.77,2.4,5.7,1.77A10.29,10.29,0,0,0,251,8.07a19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.81,2.31-2.81-2.32-2.09-4-.82-5.54,1.69C248.05,5.63,247.12,6.5,245.53,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-340",
    d: "M246.23-3.26a2.94,2.94,0,0,0-1.6.48,2.81,2.81,0,0,0-1.07,1.29,2.86,2.86,0,0,0,.62,3.14,2.88,2.88,0,0,0,4.07,0,2.87,2.87,0,0,0,.85-2,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-341",
    d: "M255.42,5.67c3,6-4.23,7.9-8.82,8.17s-4.56,2.8-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.52-5.62-1-2.13-1.26-3.38.48-4.17a8.72,8.72,0,0,1,1.81-.52,13.21,13.21,0,0,0,7-3.34,5.09,5.09,0,0,0,.46-.58,5.7,5.7,0,0,0,.64-1.16C260,8.61,255.69,5.84,255.42,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-342",
    d: "M251.47,24.57a2.73,2.73,0,0,0,1,.4,2.84,2.84,0,0,0,2.91-1.31,2.94,2.94,0,0,0,.44-1.61,2.87,2.87,0,0,0-2.95-2.78,2.78,2.78,0,0,0-.57.07,2.92,2.92,0,0,0-1.44.83,2.88,2.88,0,0,0-.53,3.14A3,3,0,0,0,251.47,24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M239.3,9.36a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a9,9,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73a4.43,4.43,0,0,0,.28.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.87-6.67-.23-4.86-7.53-2.9-11.71S240.3,9.81,239.3,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M231.63,19.36a2.91,2.91,0,0,0,1.16-1.2,2.83,2.83,0,0,0,.29-1.64,2.8,2.8,0,0,0-.67-1.53,2.84,2.84,0,0,0-1.4-.9,3,3,0,0,0-1.67,0,2.89,2.89,0,0,0-1.36,1,2.74,2.74,0,0,0-.61,1.55,2.86,2.86,0,0,0,4.26,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M213.17,5.43a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.71-5.7-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.3,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C215.69,5.63,214.76,6.5,213.17,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M213.87-3.26a2.94,2.94,0,0,0-1.6.48,2.81,2.81,0,0,0-1.07,1.29,2.86,2.86,0,0,0,.62,3.14,2.88,2.88,0,0,0,4.07,0,2.87,2.87,0,0,0,.85-2,2.9,2.9,0,0,0-2.87-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M223.06,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.52,3.92A10.6,10.6,0,0,0,211,21.7a18.33,18.33,0,0,0,2,3.09c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.13-1.26-3.38.49-4.17a8.06,8.06,0,0,1,1.8-.52c2.77-.55,5.41-1.63,7-3.34a3.66,3.66,0,0,0,.46-.58,5.26,5.26,0,0,0,.64-1.16C227.63,8.61,223.33,5.84,223.06,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M219.11,24.57a2.73,2.73,0,0,0,1,.4A2.84,2.84,0,0,0,223,23.66a3,3,0,0,0,.41-1.06,2.69,2.69,0,0,0,0-1.13,2.85,2.85,0,0,0-.46-1,2.9,2.9,0,0,0-.82-.78,2.73,2.73,0,0,0-1-.4,3,3,0,0,0-1.11,0,2.85,2.85,0,0,0-1.79,1.28,3.07,3.07,0,0,0-.41,1.05,3.12,3.12,0,0,0,0,1.14,3.19,3.19,0,0,0,1.27,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M206.94,9.36a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.21,3.87,4.17,4,2.35.13,3.56.52,3.41,2.43a8.39,8.39,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73a5.72,5.72,0,0,0,.28.68,5.79,5.79,0,0,0,.71,1.13c2.91,3.5,7.39,1,7.67.87-6.67-.23-4.86-7.53-2.9-11.71S207.94,9.81,206.94,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M199.28,19.36a2.9,2.9,0,0,0,1.46-2.85A2.87,2.87,0,0,0,197.57,14a3,3,0,0,0-.59.13,2.9,2.9,0,0,0-1.83,3.66,3.06,3.06,0,0,0,.22.49,2.87,2.87,0,0,0,3.91,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-351",
    d: "M180.81,5.43a8.81,8.81,0,0,1-1.4-1.26c-2.52-2.71-5.7-4.74-8.56-4.17-4.46.84-4.51,6-4.51,6.3,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,19.38,19.38,0,0,0,1.55-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C183.33,5.63,182.4,6.5,180.81,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M181.51-3.26a2.94,2.94,0,0,0-1.6.48,2.81,2.81,0,0,0-1.07,1.29,2.86,2.86,0,0,0,.62,3.14,2.88,2.88,0,0,0,4.07,0,2.87,2.87,0,0,0,.85-2,2.77,2.77,0,0,0-.22-1.1A2.83,2.83,0,0,0,182.61-3,2.8,2.8,0,0,0,181.51-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-353",
    d: "M190.7,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09c1.93,2.41,1.14,3.46,1.14,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.13-1.26-3.38.49-4.17a8.06,8.06,0,0,1,1.8-.52c2.77-.55,5.41-1.63,7-3.34A3.66,3.66,0,0,0,193,14a5.26,5.26,0,0,0,.64-1.16C195.27,8.61,191,5.84,190.7,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-354",
    d: "M186.75,24.57a2.85,2.85,0,0,0,1.61.43,2.8,2.8,0,0,0,1.58-.53,2.89,2.89,0,0,0,1-1.31,2.8,2.8,0,0,0,.12-1.67,2.85,2.85,0,0,0-.82-1.45,2.9,2.9,0,0,0-4.83,1.58,2.74,2.74,0,0,0,0,1.14,3,3,0,0,0,.46,1A2.73,2.73,0,0,0,186.75,24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M174.58,9.36a10.21,10.21,0,0,0-4.05-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.17,4,2.35.13,3.56.52,3.41,2.43a8.39,8.39,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.42,7.73a4.48,4.48,0,0,0,.29.68,5.75,5.75,0,0,0,.7,1.13c2.91,3.5,7.39,1,7.67.87-6.68-.23-4.87-7.53-2.91-11.71S175.59,9.81,174.58,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-356",
    d: "M166.92,19.36a3,3,0,0,0,1.17-1.2,2.88,2.88,0,0,0-1.78-4.09,2.83,2.83,0,0,0-1.68,0,2.92,2.92,0,0,0-1.37,1,2.86,2.86,0,0,0-.24,3.2,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A2.9,2.9,0,0,0,166.92,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M148.46,5.43a8.88,8.88,0,0,1-1.41-1.26c-2.52-2.71-5.69-4.74-8.56-4.17C134,.84,134,6,134,6.3c3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18,17.69,17.69,0,0,0,1.55-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C151,5.63,150,6.5,148.46,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M149.15-3.26a2.94,2.94,0,0,0-1.6.48,2.81,2.81,0,0,0-1.07,1.29,2.86,2.86,0,0,0,.62,3.14,2.88,2.88,0,0,0,4.07,0,2.87,2.87,0,0,0,.85-2,2.77,2.77,0,0,0-.22-1.1A2.83,2.83,0,0,0,150.25-3,2.8,2.8,0,0,0,149.15-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M158.34,5.67c3,6-4.24,7.9-8.83,8.17S145,16.64,145,17.76a10.6,10.6,0,0,0,1.27,3.94,17.94,17.94,0,0,0,2,3.09c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.8-2.93,1.52-5.62-1-2.13-1.25-3.38.49-4.17a8.63,8.63,0,0,1,1.8-.52c2.78-.55,5.41-1.63,7-3.34a3.66,3.66,0,0,0,.46-.58,4.88,4.88,0,0,0,.64-1.16C162.92,8.61,158.62,5.84,158.34,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M154.4,24.57a2.73,2.73,0,0,0,1,.4,2.86,2.86,0,0,0,2.14-.49,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,2.81,2.81,0,0,0-5,2.3,2.86,2.86,0,0,0,1.16,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M142.23,9.36a10.29,10.29,0,0,0-4.06-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.18,5.54-.43,7.73a4.48,4.48,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.9,3.5,7.38,1,7.66.87-6.68-.23-4.87-7.53-2.91-11.71S143.23,9.81,142.23,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-362",
    d: "M134.56,19.36a2.88,2.88,0,0,0,1.13-3.91,2.56,2.56,0,0,0-.33-.48,2.86,2.86,0,0,0-1.41-.9,2.83,2.83,0,0,0-1.68,0,2.92,2.92,0,0,0-1.37,1,2.86,2.86,0,0,0-.24,3.2,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A2.9,2.9,0,0,0,134.56,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M116.1,5.43a8.88,8.88,0,0,1-1.41-1.26C112.17,1.46,109-.57,106.13,0c-4.46.84-4.51,6-4.51,6.3,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.46,10.46,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C118.61,5.63,117.68,6.5,116.1,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-364",
    d: "M116.79-3.26a2.94,2.94,0,0,0-1.6.48,2.81,2.81,0,0,0-1.07,1.29,2.86,2.86,0,0,0,.62,3.14,2.88,2.88,0,0,0,3.14.63,2.9,2.9,0,0,0,1.78-2.66,2.77,2.77,0,0,0-.22-1.1A2.83,2.83,0,0,0,117.89-3,2.77,2.77,0,0,0,116.79-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-365",
    d: "M126,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.52,3.92a10.62,10.62,0,0,0,1.28,3.94,17.94,17.94,0,0,0,2,3.09c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.13-1.25-3.38.49-4.17a8.15,8.15,0,0,1,1.81-.52,13.21,13.21,0,0,0,7-3.34,3.66,3.66,0,0,0,.46-.58,4.88,4.88,0,0,0,.64-1.16C130.56,8.61,126.26,5.84,126,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-366",
    d: "M122,24.57a2.73,2.73,0,0,0,1,.4,2.61,2.61,0,0,0,2.13-.46,3,3,0,0,0,.76-.82,2.91,2.91,0,0,0,.38-2.19,2.87,2.87,0,0,0-.47-1,3,3,0,0,0-1.88-1.2,3.07,3.07,0,0,0-1.13,0,2.55,2.55,0,0,0-1,.47,2.78,2.78,0,0,0-.77.83,2.8,2.8,0,0,0,.12,3.2A3,3,0,0,0,122,24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-367",
    d: "M109.87,9.36a10.29,10.29,0,0,0-4.06-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.69,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.17,5.54-.43,7.73a5.79,5.79,0,0,0,.29.68,4.58,4.58,0,0,0,.71,1.13c2.9,3.5,7.38,1,7.66.87-6.68-.23-4.87-7.53-2.91-11.71S110.87,9.81,109.87,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-368",
    d: "M102.2,19.36a2.87,2.87,0,1,0-3.65-4.24,2.74,2.74,0,0,0-.61,1.55,2.88,2.88,0,0,0,3.2,3.08A2.82,2.82,0,0,0,102.2,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-369",
    d: "M83.74,5.43a8.88,8.88,0,0,1-1.41-1.26C79.81,1.46,76.64-.57,73.77,0c-4.46.84-4.51,6-4.51,6.3,3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77A10.32,10.32,0,0,0,89.2,8.07a18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.31-2.81,2.31-2.81-2.31-2.09-4-.82-5.54,1.69C86.26,5.63,85.32,6.5,83.74,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-370",
    d: "M84.44-3.26A2.88,2.88,0,0,0,81.77-1.5,2.82,2.82,0,0,0,81.59.17a2.9,2.9,0,0,0,2.26,2.27,2.81,2.81,0,0,0,1.67-.16A2.9,2.9,0,0,0,87.3-.38a3,3,0,0,0-.21-1.1,3.09,3.09,0,0,0-.62-.93,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-371",
    d: "M93.62,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.51,3.92a10.6,10.6,0,0,0,1.27,3.94,17.94,17.94,0,0,0,2,3.09c1.92,2.41,1.13,3.46,1.13,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.13-1.25-3.38.49-4.17a8.15,8.15,0,0,1,1.81-.52,13.21,13.21,0,0,0,7-3.34A3.66,3.66,0,0,0,96,14a5.74,5.74,0,0,0,.65-1.16C98.2,8.61,93.9,5.84,93.62,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-372",
    d: "M89.68,24.57a2.73,2.73,0,0,0,1,.4,2.86,2.86,0,0,0,2.14-.49,3,3,0,0,0,.76-.82A2.91,2.91,0,0,0,94,21.47a2.87,2.87,0,0,0-.47-1,3,3,0,0,0-1.88-1.2,3.07,3.07,0,0,0-1.13,0,2.55,2.55,0,0,0-1,.47,2.78,2.78,0,0,0-.77.83,2.89,2.89,0,0,0-.36,2.2,3.11,3.11,0,0,0,1.33,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-373",
    d: "M77.51,9.36a10.29,10.29,0,0,0-4.06-.77,18.59,18.59,0,0,0-3.65.28c-3,.54-3.56-.66-3.56-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.55.52,3.4,2.43a9,9,0,0,1-.4,1.85c-.86,2.7-1.17,5.54-.43,7.73a5.79,5.79,0,0,0,.29.68A4.58,4.58,0,0,0,74,26c2.91,3.5,7.38,1,7.67.87-6.68-.23-4.86-7.53-2.91-11.71S78.51,9.81,77.51,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-374",
    d: "M69.84,19.36A2.91,2.91,0,0,0,71,18.16a2.83,2.83,0,0,0,.29-1.64A2.8,2.8,0,0,0,70.62,15a2.84,2.84,0,0,0-1.4-.9,3,3,0,0,0-1.67,0,2.89,2.89,0,0,0-1.36,1,2.74,2.74,0,0,0-.61,1.55,2.84,2.84,0,0,0,4.26,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-375",
    d: "M51.38,5.43A8.68,8.68,0,0,1,50,4.17C47.48,1.46,44.31-.57,41.44,0,37,.84,36.93,6,36.93,6.3c3.46-5.74,8.91-.58,11.58,3.18s4.78,2.4,5.7,1.77a10.32,10.32,0,0,0,2.66-3.18,18.61,18.61,0,0,0,1.54-3.33c1-2.92,2.32-2.81,2.32-2.81-2.31-2.09-3.95-.82-5.54,1.69C53.9,5.63,53,6.5,51.38,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-376",
    d: "M52.08-3.26A2.88,2.88,0,0,0,49.41-1.5,2.82,2.82,0,0,0,49.23.17a2.9,2.9,0,0,0,2.26,2.27,2.86,2.86,0,0,0,3-1.22A2.85,2.85,0,0,0,55-.38a3,3,0,0,0-.21-1.1,3.09,3.09,0,0,0-.62-.93,2.85,2.85,0,0,0-2-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-377",
    d: "M61.27,5.67c3,6-4.24,7.9-8.83,8.17s-4.56,2.8-4.51,3.92A10.6,10.6,0,0,0,49.2,21.7a17.94,17.94,0,0,0,2,3.09c1.92,2.41,1.14,3.46,1.14,3.46,3-.86,2.79-2.93,1.51-5.62-1-2.13-1.25-3.38.49-4.17a8.15,8.15,0,0,1,1.81-.52,13.21,13.21,0,0,0,7-3.34,3.66,3.66,0,0,0,.46-.58,5.74,5.74,0,0,0,.65-1.16C65.84,8.61,61.54,5.84,61.27,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-378",
    d: "M57.32,24.57a2.87,2.87,0,0,0,1.06.42,2.69,2.69,0,0,0,1.13,0,2.85,2.85,0,0,0,1-.46,2.94,2.94,0,0,0,.77-.84,2.91,2.91,0,0,0,.38-2.19,3,3,0,0,0-.46-1,3.24,3.24,0,0,0-.83-.78,2.76,2.76,0,0,0-3.19.08,2.78,2.78,0,0,0-.77.83,2.85,2.85,0,0,0,.91,3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-379",
    d: "M45.15,9.36a10.36,10.36,0,0,0-4-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.4,2.43a8.37,8.37,0,0,1-.4,1.85c-.85,2.7-1.17,5.54-.43,7.73a6.68,6.68,0,0,0,1,1.81c2.91,3.5,7.39,1,7.67.87-6.68-.23-4.86-7.53-2.91-11.71S46.15,9.81,45.15,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-380",
    d: "M37.48,19.36a2.87,2.87,0,0,0,1.1-3.92,2.82,2.82,0,0,0-1.72-1.36A3,3,0,0,0,35.74,14a3.08,3.08,0,0,0-1.06.35,2.87,2.87,0,0,0-1.1,3.92,2.82,2.82,0,0,0,1.72,1.36,2.64,2.64,0,0,0,1.12.09A3.08,3.08,0,0,0,37.48,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-381",
    d: "M19,5.43a8.81,8.81,0,0,1-1.4-1.26C15.07,1.46,11.9-.57,9,0,4.58.84,4.52,6,4.52,6.3,8,.56,13.43,5.72,16.11,9.48s4.77,2.4,5.7,1.77a10.29,10.29,0,0,0,2.65-3.18A18.52,18.52,0,0,0,26,4.75c1-2.92,2.32-2.81,2.32-2.81-2.32-2.09-4-.82-5.55,1.69C21.54,5.63,20.61,6.5,19,5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-382",
    d: "M19.72-3.26a2.89,2.89,0,0,0-1.61.48A3,3,0,0,0,17-1.5,2.9,2.9,0,0,0,16.83.17a2.9,2.9,0,0,0,2.26,2.27,2.81,2.81,0,0,0,1.67-.16,2.88,2.88,0,0,0,1.56-3.76,3.09,3.09,0,0,0-.62-.93A2.89,2.89,0,0,0,19.72-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-383",
    d: "M28.91,5.67c3,6-4.24,7.9-8.82,8.17s-4.57,2.8-4.52,3.92a10.6,10.6,0,0,0,1.27,3.94,18.33,18.33,0,0,0,2,3.09C20.76,27.2,20,28.25,20,28.25c3-.86,2.79-2.93,1.51-5.62-1-2.13-1.25-3.38.49-4.17a8.72,8.72,0,0,1,1.81-.52,13.21,13.21,0,0,0,7-3.34,3.6,3.6,0,0,0,.45-.58,5.74,5.74,0,0,0,.65-1.16C33.48,8.61,29.18,5.84,28.91,5.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-384",
    d: "M25,24.57a2.87,2.87,0,0,0,3.19-.09,3,3,0,0,0,.76-.82,2.94,2.94,0,0,0,.44-1.61,2.87,2.87,0,0,0-3-2.76,2.51,2.51,0,0,0-.55.07,2.92,2.92,0,0,0-1.44.83,2.86,2.86,0,0,0-.53,3.17A2.92,2.92,0,0,0,25,24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-385",
    d: "M12.79,9.36a10.36,10.36,0,0,0-4-.77,17.86,17.86,0,0,0-3.65.28c-3,.54-3.57-.66-3.57-.66-.68,3,1.22,3.87,4.18,4,2.34.13,3.56.52,3.41,2.43a9,9,0,0,1-.41,1.85c-.85,2.7-1.17,5.54-.43,7.73a6.68,6.68,0,0,0,1,1.81c2.91,3.5,7.39,1,7.67.87-6.68-.23-4.86-7.53-2.9-11.71S13.79,9.81,12.79,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-386",
    d: "M5.12,19.36a2.87,2.87,0,0,0-2.8-5,2.87,2.87,0,0,0-1.1,3.92,2.71,2.71,0,0,0,.73.85,2.94,2.94,0,0,0,1,.5,2.82,2.82,0,0,0,1.12.08A2.61,2.61,0,0,0,5.12,19.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-387",
    d: "M389,104.26s-21.25-1.89-37.82,45.73a303.33,303.33,0,0,1-25.26,54.37c-23.7,14.07-45.2,4.85-61.73-9.59a114.31,114.31,0,0,0,28.15-12.11C315,169.07,329,132.74,346.09,112.5c16.78-19.92,42-8.65,42.87-8.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-388",
    d: "M389,104.24c-.84-.39-26.1-11.66-42.88,8.26-17.09,20.26-31,56.59-53.74,70.16a113.61,113.61,0,0,1-28.15,12.11c-12.37-10.82-21.93-24.55-27.54-33.65,25.94,17.41,41.19,3.18,61.72-29.3C324.31,90.81,351.16,70.12,389,104.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-389",
    d: "M389,104.24c-.84-.39-26.1-11.66-42.88,8.26-17.09,20.26-31,56.59-53.74,70.16a113.61,113.61,0,0,1-28.15,12.11c-12.37-10.82-21.93-24.55-27.54-33.65,25.94,17.41,41.19,3.18,61.72-29.3C324.31,90.81,351.16,70.12,389,104.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-390",
    d: "M325.92,204.36c-14,23.68-29.77,42.52-43.38,51.81-15.09,10.34-48.84,33.51-93.2-28.83C145.67,166,56.54,81.78,0,175.51v-.26c0-5.32.84-89,73.75-102.63,46.86-9.4,98.72,23.8,140,68,8.57,9.2,16.14,16,23,20.52,5.58,9.11,15.17,22.83,27.53,33.65C280.71,209.23,302.22,218.45,325.92,204.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-391",
    d: "M292.68,183.24l-.42-.53c14.29-8.55,24.81-26.86,35.25-43.93a212.31,212.31,0,0,1,18.58-26.28c-6.19,7.33-11.37,17.11-17.42,27C318.15,156.71,307.27,174.53,292.68,183.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-392",
    d: "M0,175.26s8.34-52.52,32.18-75.39c21.31-20.42,66.69-52.9,125,.94,56,51.74,91.24,130.63,143.73,117.47,0,0-35.62,42.59-70.29,2.83s-78.47-97.75-117.83-112.46S16.55,127.23,0,175.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-393",
    d: "M230.59,221.08q-6.85-7.67-13.61-15.38l-13.41-15.54c-9-10.35-17.93-20.68-27.28-30.66A359.62,359.62,0,0,0,147,130.88l-3.89-3.33c-1.32-1.09-2.7-2.09-4-3.14L135,121.29l-4.24-2.86a99.65,99.65,0,0,0-18-9.81c12.87,4.74,24.31,12.74,34.84,21.45a337.88,337.88,0,0,1,29.64,28.49c9.29,10.06,18.27,20.41,27.08,30.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-394",
    d: "M254.33,118.36a47,47,0,1,0-18-3.6A47,47,0,0,0,254.33,118.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastBack0101);
export default __webpack_public_path__ + "static/media/LastBack-01-01.3e781c4ca39c9eb566eabdc4a6e2be44.svg";
export { ForwardRef as ReactComponent };